export const SOLUTIONS: {
  reference: string
  verseText: string
  referenceURL: string
}[] = [
  {
    reference: '1 JOHN 1:1',
    referenceURL: 'https://www.bible.com/bible/1/1JN.1.1.KJV',
    verseText:
      'That which was from the beginning, which we have heard, which we have seen with our eyes, which we have looked upon, and our hands have handled, of the Word of life; ',
  },
  {
    reference: 'SONG OF SOLOMON 8:13',
    referenceURL: 'https://www.bible.com/bible/1/SNG.8.13.KJV',
    verseText:
      'Thou that dwellest in the gardens,The companions hearken to thy voice: Cause me to hear it. ',
  },
  {
    reference: 'JUDE 3',
    referenceURL: 'https://www.bible.com/bible/1/JUD.1.3.KJV',
    verseText:
      'Beloved, when I gave all diligence to write unto you of the common salvation, it was needful for me to write unto you, and exhort you that ye should earnestly contend for the faith which was once delivered unto the saints. ',
  },
  {
    reference: 'JOHN 3:16',
    referenceURL: 'https://www.bible.com/bible/1/JHN.3.16.KJV',
    verseText:
      'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.',
  },
  {
    reference: 'JOHN 15:5',
    referenceURL: 'https://www.bible.com/bible/1/JHN.15.5.KJV',
    verseText:
      'I am the vine, ye are the branches: He that abideth in me, and I in him, the same bringeth forth much fruit: for without me ye can do nothing.',
  },
  {
    reference: 'REVELATION 1:13',
    referenceURL: 'https://www.bible.com/bible/1/REV.1.13.KJV',
    verseText:
      'and in the midst of the seven candlesticks one like unto the Son of man, clothed with a garment down to the foot, and girt about the paps with a golden girdle.',
  },
  {
    reference: 'PSALM 133:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.133.1.KJV',
    verseText:
      'Behold, how good and how pleasant it is For brethren to dwell together in unity!',
  },
  {
    reference: 'ISAIAH 2:19',
    referenceURL: 'https://www.bible.com/bible/1/ISA.2.19.KJV',
    verseText:
      'And they shall go into the holes of the rocks, and into the caves of the earth, for fear of the LORD, and for the glory of his majesty, when he ariseth to shake terribly the earth.',
  },
  {
    reference: '1 PETER 5:6',
    referenceURL: 'https://www.bible.com/bible/1/1PE.5.6.KJV',
    verseText:
      'Humble yourselves therefore under the mighty hand of God, that he may exalt you in due time',
  },
  {
    reference: '1 PETER 1:13',
    referenceURL: 'https://www.bible.com/bible/1/1PE.1.13.KJV',
    verseText:
      'Wherefore gird up the loins of your mind, be sober, and hope to the end for the grace that is to be brought unto you at the revelation of Jesus Christ',
  },
  {
    reference: 'GENESIS 30:13',
    referenceURL: 'https://www.bible.com/bible/1/gen.30.13.KJV',
    verseText:
      'And Leah said, Happy am I, for the daughters will call me blessed: and she called his name Asher.',
  },
  {
    reference: 'GENESIS 41:49',
    referenceURL: 'https://www.bible.com/bible/1/GEN.41.49.KJV',
    verseText:
      'And Joseph gathered corn as the sand of the sea, very much, until he left numbering; for it was without number.',
  },
  {
    reference: 'ACTS 19:34',
    referenceURL: 'https://www.bible.com/bible/1/ACT.19.34.KJV',
    verseText:
      'But when they knew that he was a Jew, all with one voice about the space of two hours cried out, Great is Diana of the Ephesians.',
  },
  {
    reference: 'PSALM 17:15',
    referenceURL: 'https://www.bible.com/bible/1/PSA.17.15.KJV',
    verseText:
      'As for me, I will behold thy face in righteousness: I shall be satisfied, when I awake, with thy likeness.',
  },
  {
    reference: 'ROMANS 6:23',
    referenceURL: 'https://www.bible.com/bible/1/rom.6.23.KJV',
    verseText:
      'For the wages of sin is death; but the gift of God is eternal life through Jesus Christ our Lord.',
  },
  {
    reference: 'LUKE 3:7',
    referenceURL: 'https://www.bible.com/bible/1/LUK.3.7.KJV',
    verseText:
      'Then said he to the multitude that came forth to be baptized of him, O generation of vipers, who hath warned you to flee from the wrath to come?',
  },
  {
    reference: 'PSALM 100:4',
    referenceURL: 'https://www.bible.com/bible/1/PSA.100.4.KJV',
    verseText:
      'Enter into his gates with thanksgiving, And into his courts with praise: Be thankful unto him, and bless his name.',
  },
  {
    reference: 'EPHESIANS 1:7',
    referenceURL: 'https://www.bible.com/bible/1/EPH.1.7.KJV',
    verseText:
      'In whom we have redemption through his blood, the forgiveness of sins, according to the riches of his grace',
  },
  {
    reference: 'COLOSSIANS 3:16',
    referenceURL: 'https://www.bible.com/bible/1/COL.3.16.KJV',
    verseText:
      'Let the word of Christ dwell in you richly in all wisdom; teaching and admonishing one another in psalms and hymns and spiritual songs, singing with grace in your hearts to the Lord.',
  },
  {
    reference: 'REVELATION 3:20',
    referenceURL: 'https://www.bible.com/bible/1/REV.3.20.KJV',
    verseText:
      'Behold, I stand at the door, and knock: if any man hear my voice, and open the door, I will come in to him, and will sup with him, and he with me.',
  },
  {
    reference: 'ROMANS 12:9',
    referenceURL: 'https://www.bible.com/bible/1/ROM.12.9.KJV',
    verseText:
      'Let love be without dissimulation. Abhor that which is evil; cleave to that which is good.',
  },
  {
    reference: '1 PETER 3:22',
    referenceURL: 'https://www.bible.com/bible/1/1PE.3.22.KJV',
    verseText:
      'who is gone into heaven, and is on the right hand of God; angels and authorities and powers being made subject unto him.',
  },
  {
    reference: 'LUKE 21:28',
    referenceURL: 'https://www.bible.com/bible/1/LUK.21.28.KJV',
    verseText:
      'And when these things begin to come to pass, then look up, and lift up your heads; for your redemption draweth nigh.',
  },
  {
    reference: 'PSALM 112:5',
    referenceURL: 'https://www.bible.com/bible/1/PSA.112.5.KJV',
    verseText:
      'A good man sheweth favour, and lendeth: He will guide his affairs with discretion.',
  },
  {
    reference: 'REVELATION 5:5',
    referenceURL: 'https://www.bible.com/bible/1/REV.5.5.KJV',
    verseText:
      'And one of the elders saith unto me, Weep not: behold, the Lion of the tribe of Juda, the Root of David, hath prevailed to open the book, and to loose the seven seals thereof.',
  },
  {
    reference: '1 CORINTHIANS 14:12',
    referenceURL: 'https://www.bible.com/bible/1/1CO.14.12.KJV',
    verseText:
      'Even so ye, forasmuch as ye are zealous of spiritual gifts, seek that ye may excel to the edifying of the church.',
  },
  {
    reference: 'LUKE 19:7',
    referenceURL: 'https://www.bible.com/bible/1/LUK.19.7.KJV',
    verseText:
      'And when they saw it, they all murmured, saying, That he was gone to be guest with a man that is a sinner.',
  },
  {
    reference: 'ISAIAH 40:31',
    referenceURL: 'https://www.bible.com/bible/1/isa.40.31.KJV',
    verseText:
      'but they that wait upon the LORD shall renew their strength; they shall mount up with wings as eagles; they shall run, and not be weary; and they shall walk, and not faint.',
  },
  {
    reference: 'PSALM 121:1',
    referenceURL: 'https://www.bible.com/bible/1/psa.121.1.KJV',
    verseText:
      'I will lift up mine eyes unto the hills,From whence cometh my help.',
  },
  {
    reference: 'JOHN 12:3',
    referenceURL: 'https://www.bible.com/bible/1/JHN.12.3.KJV',
    verseText:
      'Then took Mary a pound of ointment of spikenard, very costly, and anointed the feet of Jesus, and wiped his feet with her hair: and the house was filled with the odour of the ointment.',
  },
  {
    reference: 'EXODUS 20:16',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.16.KJV',
    verseText: 'Thou shalt not bear false witness against thy neighbour.',
  },
  {
    reference: 'GENESIS 25:25',
    referenceURL: 'https://www.bible.com/bible/1/GEN.25.25.KJV',
    verseText:
      'And the first came out red, all over like an hairy garment; and they called his name Esau.',
  },
  {
    reference: 'PSALM 89:34',
    referenceURL: 'https://www.bible.com/bible/1/PSA.89.34.KJV',
    verseText:
      'My covenant will I not break, nor alter the thing that is gone out of my lips.',
  },
  {
    reference: 'ROMANS 12:14',
    referenceURL: 'https://www.bible.com/bible/1/ROM.12.14.KJV',
    verseText: 'Bless them which persecute you: bless, and curse not.',
  },
  {
    reference: 'JUDGES 15:15',
    referenceURL: 'https://www.bible.com/bible/1/JDG.15.15.KJV',
    verseText:
      'And he found a new jawbone of an ass, and put forth his hand, and took it, and slew a thousand men therewith.',
  },
  {
    reference: '1 PETER 1:13',
    referenceURL: 'https://www.bible.com/bible/1/1pe.1.13.KJV',
    verseText:
      'Wherefore gird up the loins of your mind, be sober, and hope to the end for the grace that is to be brought unto you at the revelation of Jesus Christ',
  },
  {
    reference: 'PSALM 16:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.16.2.KJV',
    verseText:
      'O my soul, thou hast said unto the LORD, Thou art my Lord: My goodness extendeth not to thee',
  },
  {
    reference: 'MATTHEW 3:4',
    referenceURL: 'https://www.bible.com/bible/1/mat.3.4.KJV',
    verseText:
      "And the same John had his raiment of camel's hair, and a leathern girdle about his loins; and his meat was locusts and wild honey.",
  },
  {
    reference: 'EPHESIANS 1:4',
    referenceURL: 'https://www.bible.com/bible/1/EPH.1.4.KJV',
    verseText:
      'according as he hath chosen us in him before the foundation of the world, that we should be holy and without blame before him in love',
  },
  {
    reference: 'PSALM 64:7',
    referenceURL: 'https://www.bible.com/bible/1/PSA.64.7.KJV',
    verseText:
      'But God shall shoot at them With an arrow; suddenly shall they be wounded.',
  },
  {
    reference: 'EXODUS 12:39',
    referenceURL: 'https://www.bible.com/bible/1/EXO.12.39.KJV',
    verseText:
      'And they baked unleavened cakes of the dough which they brought forth out of Egypt, for it was not leavened; because they were thrust out of Egypt, and could not tarry, neither had they prepared for themselves any victual.',
  },
  {
    reference: 'LUKE 24:2',
    referenceURL: 'https://www.bible.com/bible/1/luk.24.2.KJV',
    verseText: 'And they found the stone rolled away from the sepulchre.',
  },
  {
    reference: 'PSALM 46:7',
    referenceURL: 'https://www.bible.com/bible/1/PSA.46.7.KJV',
    verseText:
      'The LORD of hosts is with us; The God of Jacob is our refuge. Selah.',
  },
  {
    reference: 'LUKE 8:24',
    referenceURL: 'https://www.bible.com/bible/1/LUK.8.24.KJV',
    verseText:
      'And they came to him, and awoke him, saying, Master, master, we perish. Then he arose, and rebuked the wind and the raging of the water: and they ceased, and there was a calm.',
  },
  {
    reference: 'GENESIS 5:24',
    referenceURL: 'https://www.bible.com/bible/1/GEN.5.24.KJV',
    verseText: 'and Enoch walked with God: and he was not; for God took him.',
  },
  {
    reference: 'MATTHEW 11:29',
    referenceURL: 'https://www.bible.com/bible/1/MAT.11.29.KJV',
    verseText:
      'Take my yoke upon you, and learn of me; for I am meek and lowly in heart: and ye shall find rest unto your souls.',
  },
  {
    reference: '1 CORINTHIANS 15:55',
    referenceURL: 'https://www.bible.com/bible/1/1CO.15.55.KJV',
    verseText: 'O death, where is thy sting? O grave, where is thy victory?',
  },
  {
    reference: 'MATTHEW 6:20',
    referenceURL: 'https://www.bible.com/bible/1/MAT.6.20.KJV',
    verseText:
      'but lay up for yourselves treasures in heaven, where neither moth nor rust doth corrupt, and where thieves do not break through nor steal',
  },
  {
    reference: 'JUDGES 1:4',
    referenceURL: 'https://www.bible.com/bible/1/JDG.1.4.KJV',
    verseText:
      'And Judah went up; and the LORD delivered the Canaanites and the Perizzites into their hand: and they slew of them in Bezek ten thousand men.',
  },
  {
    reference: '1 CORINTHIANS 4:3',
    referenceURL: 'https://www.bible.com/bible/1/1Co.4.3.KJV',
    verseText:
      "But with me it is a very small thing that I should be judged of you, or of man's judgment: yea, I judge not mine own self.",
  },
  {
    reference: 'MATTHEW 10:30',
    referenceURL: 'https://www.bible.com/bible/1/MAT.10.30.KJV',
    verseText: 'But the very hairs of your head are all numbered.',
  },
  {
    reference: 'PSALM 95:6',
    referenceURL: 'https://www.bible.com/bible/1/PSA.95.6.KJV',
    verseText:
      'O come, let us worship and bow down: Let us kneel before the LORD our maker.',
  },
  {
    reference: 'MATTHEW 18:12',
    referenceURL: 'https://www.bible.com/bible/1/MAT.18.12.KJV',
    verseText:
      'How think ye? if a man have an hundred sheep, and one of them be gone astray, doth he not leave the ninety and nine, and goeth into the mountains, and seeketh that which is gone astray?',
  },
  {
    reference: 'ISAIAH 46:4',
    referenceURL: 'https://www.bible.com/bible/1/ISA.46.4.KJV',
    verseText:
      'and even to your old age I am he; and even to hoar hairs will I carry you: I have made, and I will bear; even I will carry, and will deliver you.',
  },
  {
    reference: 'JUDGES 15:4',
    referenceURL: 'https://www.bible.com/bible/1/JDG.15.4.KJV',
    verseText:
      'And Samson went and caught three hundred foxes, and took firebrands, and turned tail to tail, and put a firebrand in the midst between two tails.',
  },
  {
    reference: 'MATTHEW 11:28',
    referenceURL: 'https://www.bible.com/bible/1/mat.11.28.KJV',
    verseText:
      'Come unto me, all ye that labour and are heavy laden, and I will give you rest.',
  },
  {
    reference: '2 CORINTHIANS 4:16',
    referenceURL: 'https://www.bible.com/bible/1/2Co.4.16.KJV',
    verseText:
      'For which cause we faint not; but though our outward man perish, yet the inward man is renewed day by day.',
  },
  {
    reference: 'EXODUS 19:5',
    referenceURL: 'https://www.bible.com/bible/1/EXO.19.5.KJV',
    verseText:
      'Now therefore, if ye will obey my voice indeed, and keep my covenant, then ye shall be a peculiar treasure unto me above all people: for all the earth is mine',
  },
  {
    reference: '2 CORINTHIANS 13:12',
    referenceURL: 'https://www.bible.com/bible/1/2CO.13.12.KJV',
    verseText: 'Greet one another with an holy kiss.',
  },
  {
    reference: 'PROVERBS 24:10',
    referenceURL: 'https://www.bible.com/bible/1/pro.24.10.KJV',
    verseText: 'If thou faint in the day of adversity, Thy strength is small.',
  },
  {
    reference: 'JOSHUA 4:23',
    referenceURL: 'https://www.bible.com/bible/1/JOS.4.23.KJV',
    verseText:
      'For the LORD your God dried up the waters of Jordan from before you, until ye were passed over, as the LORD your God did to the Red sea, which he dried up from before us, until we were gone over',
  },
  {
    reference: 'PROVERBS 23:12',
    referenceURL: 'https://www.bible.com/bible/1/PRO.23.12.KJV',
    verseText:
      'Apply thine heart unto instruction, And thine ears to the words of knowledge.',
  },
  {
    reference: 'PROVERBS 15:17',
    referenceURL: 'https://www.bible.com/bible/1/PRO.15.17.KJV',
    verseText:
      'Better is a dinner of herbs where love is, Than a stalled ox and hatred therewith.',
  },
  {
    reference: 'PSALM 36:7',
    referenceURL: 'https://www.bible.com/bible/1/PSA.36.7.KJV',
    verseText:
      'How excellent is thy lovingkindness, O God! Therefore the children of men put their trust under the shadow of thy wings.',
  },
  {
    reference: 'LUKE 9:58',
    referenceURL: 'https://www.bible.com/bible/1/LUK.9.58.KJV',
    verseText:
      'And Jesus said unto him, Foxes have holes, and birds of the air have nests; but the Son of man hath not where to lay his head.',
  },
  {
    reference: 'GENESIS 9:11',
    referenceURL: 'https://www.bible.com/bible/1/GEN.9.11.KJV',
    verseText:
      'And I will establish my covenant with you; neither shall all flesh be cut off any more by the waters of a flood; neither shall there any more be a flood to destroy the earth.',
  },
  {
    reference: 'LUKE 16:26',
    referenceURL: 'https://www.bible.com/bible/1/LUK.16.26.KJV',
    verseText:
      'And beside all this, between us and you there is a great gulf fixed: so that they which would pass from hence to you cannot; neither can they pass to us, that would come from thence.',
  },
  {
    reference: '2 TIMOTHY 3:12',
    referenceURL: 'https://www.bible.com/bible/1/2TI.3.12.KJV',
    verseText:
      'Yea, and all that will live godly in Christ Jesus shall suffer persecution.',
  },
  {
    reference: '2 CORINTHIANS 9:7',
    referenceURL: 'https://www.bible.com/bible/1/2CO.9.7.KJV',
    verseText:
      'Every man according as he purposeth in his heart, so let him give; not grudgingly, or of necessity: for God loveth a cheerful giver.',
  },
  {
    reference: 'EPHESIANS 6:11',
    referenceURL: 'https://www.bible.com/bible/1/EPH.6.11.KJV',
    verseText:
      'Put on the whole armour of God, that ye may be able to stand against the wiles of the devil.',
  },
  {
    reference: 'MATTHEW 7:11',
    referenceURL: 'https://www.bible.com/bible/1/MAT.7.11.KJV',
    verseText:
      'If ye then, being evil, know how to give good gifts unto your children, how much more shall your Father which is in heaven give good things to them that ask him?',
  },
  {
    reference: 'REVELATION 21:2',
    referenceURL: 'https://www.bible.com/bible/1/REV.21.2.KJV',
    verseText:
      'And I John saw the holy city, new Jerusalem, coming down from God out of heaven, prepared as a bride adorned for her husband.',
  },
  {
    reference: '1 KINGS 10:18',
    referenceURL: 'https://www.bible.com/bible/1/1KI.10.18.KJV',
    verseText:
      'Moreover the king made a great throne of ivory, and overlaid it with the best gold.',
  },
  {
    reference: 'PSALM 127:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.127.1.KJV',
    verseText:
      'Except the LORD build the house, They labour in vain that build it: Except the LORD keep the city, The watchman waketh but in vain.',
  },
  {
    reference: 'COLOSSIANS 3:1',
    referenceURL: 'https://www.bible.com/bible/1/col.3.1.KJV',
    verseText:
      'If ye then be risen with Christ, seek those things which are above, where Christ sitteth on the right hand of God.',
  },
  {
    reference: 'LUKE 12:18',
    referenceURL: 'https://www.bible.com/bible/1/LUK.12.18.KJV',
    verseText:
      'And he said, This will I do: I will pull down my barns, and build greater; and there will I bestow all my fruits and my goods.',
  },
  {
    reference: 'ROMANS 12:2',
    referenceURL: 'https://www.bible.com/bible/1/ROM.12.2.KJV',
    verseText:
      'And be not conformed to this world: but be ye transformed by the renewing of your mind, that ye may prove what is that good, and acceptable, and perfect, will of God.',
  },
  {
    reference: 'NAHUM 1:5',
    referenceURL: 'https://www.bible.com/bible/1/NAM.1.5.KJV',
    verseText:
      'The mountains quake at him, and the hills melt, and the earth is burned at his presence, yea, the world, and all that dwell therein.',
  },
  {
    reference: 'ECCLESIASTES 10:1',
    referenceURL: 'https://www.bible.com/bible/1/ECC.10.1.KJV',
    verseText:
      'Dead flies cause the ointment of the apothecary to send forth a stinking savour: so doth a little folly him that is in reputation for wisdom and honour.',
  },
  {
    reference: 'JOEL 2:1',
    referenceURL: 'https://www.bible.com/bible/1/JOL.2.1.KJV',
    verseText:
      'Blow ye the trumpet in Zion, and sound an alarm in my holy mountain: let all the inhabitants of the land tremble: for the day of the LORD cometh, for it is nigh at hand',
  },
  {
    reference: 'ACTS 12:23',
    referenceURL: 'https://www.bible.com/bible/1/ACT.12.23.KJV',
    verseText:
      'And immediately the angel of the Lord smote him, because he gave not God the glory: and he was eaten of worms, and gave up the ghost.',
  },
  {
    reference: 'JONAH 2:10',
    referenceURL: 'https://www.bible.com/bible/1/JON.2.10.KJV',
    verseText:
      'And the LORD spake unto the fish, and it vomited out Jonah upon the dry land.',
  },
  {
    reference: 'MATTHEW 5:4',
    referenceURL: 'https://www.bible.com/bible/1/MAT.5.4.KJV',
    verseText: 'Blessed are they that mourn: for they shall be comforted.',
  },
  {
    reference: '1 TIMOTHY 5:8',
    referenceURL: 'https://www.bible.com/bible/1/1TI.5.8.KJV',
    verseText:
      'But if any provide not for his own, and specially for those of his own house, he hath denied the faith, and is worse than an infidel.',
  },
  {
    reference: 'PHILIPPIANS 2:4',
    referenceURL: 'https://www.bible.com/bible/1/PHP.2.4.KJV',
    verseText:
      'Look not every man on his own things, but every man also on the things of others.',
  },
  {
    reference: 'LUKE 3:17',
    referenceURL: 'https://www.bible.com/bible/1/LUK.3.17.KJV',
    verseText:
      'whose fan is in his hand, and he will throughly purge his floor, and will gather the wheat into his garner; but the chaff he will burn with fire unquenchable.',
  },
  {
    reference: 'JOB 1:22',
    referenceURL: 'https://www.bible.com/bible/1/job.1.22.KJV',
    verseText: 'In all this Job sinned not, nor charged God foolishly.',
  },
  {
    reference: 'PSALM 19:14',
    referenceURL: 'https://www.bible.com/bible/1/PSA.19.14.KJV',
    verseText:
      'Let the words of my mouth, and the meditation of my heart, be acceptable in thy sight, O LORD, my strength, and my redeemer.',
  },
  {
    reference: 'MATTHEW 9:13',
    referenceURL: 'https://www.bible.com/bible/1/mat.9.13.KJV',
    verseText:
      'But go ye and learn what that meaneth, I will have mercy, and not sacrifice: for I am not come to call the righteous, but sinners to repentance.',
  },
  {
    reference: 'LUKE 15:17',
    referenceURL: 'https://www.bible.com/bible/1/LUK.15.17.KJV',
    verseText:
      "And when he came to himself, he said, How many hired servants of my father's have bread enough and to spare, and I perish with hunger!",
  },
  {
    reference: 'EPHESIANS 3:16',
    referenceURL: 'https://www.bible.com/bible/1/EPH.3.16.KJV',
    verseText:
      'that he would grant you, according to the riches of his glory, to be strengthened with might by his Spirit in the inner man',
  },
  {
    reference: '2 CORINTHIANS 6:14',
    referenceURL: 'https://www.bible.com/bible/1/2CO.6.14.KJV',
    verseText:
      'Be ye not unequally yoked together with unbelievers: for what fellowship hath righteousness with unrighteousness? and what communion hath light with darkness?',
  },
  {
    reference: 'PROVERBS 27:23',
    referenceURL: 'https://www.bible.com/bible/1/PRO.27.23.KJV',
    verseText:
      'Be thou diligent to know the state of thy flocks, And look well to thy herds.',
  },
  {
    reference: 'ROMANS 3:23',
    referenceURL: 'https://www.bible.com/bible/1/rom.3.23.KJV',
    verseText: 'for all have sinned, and come short of the glory of God',
  },
  {
    reference: '1 TIMOTHY 6:17',
    referenceURL: 'https://www.bible.com/bible/1/1TI.6.17.KJV',
    verseText:
      'Charge them that are rich in this world, that they be not highminded, nor trust in uncertain riches, but in the living God, who giveth us richly all things to enjoy',
  },
  {
    reference: 'JOHN 1:14',
    referenceURL: 'https://www.bible.com/bible/1/JHN.1.14.KJV',
    verseText:
      'And the Word was made flesh, and dwelt among us, (and we beheld his glory, the glory as of the only begotten of the Father,) full of grace and truth.',
  },
  {
    reference: 'PSALM 34:4',
    referenceURL: 'https://www.bible.com/bible/1/PSA.34.4.KJV',
    verseText:
      'I sought the LORD, and he heard me, And delivered me from all my fears.',
  },
  {
    reference: 'PSALM 89:9',
    referenceURL: 'https://www.bible.com/bible/1/PSA.89.9.KJV',
    verseText:
      'Thou rulest the raging of the sea: When the waves thereof arise, thou stillest them.',
  },
  {
    reference: '1 CORINTHIANS 1:25',
    referenceURL: 'https://www.bible.com/bible/1/1CO.1.25.KJV',
    verseText:
      'Because the foolishness of God is wiser than men; and the weakness of God is stronger than men.',
  },
  {
    reference: 'ECCLESIASTES 2:14',
    referenceURL: 'https://www.bible.com/bible/1/ECC.2.14.KJV',
    verseText:
      "The wise man's eyes are in his head; but the fool walketh in darkness: and I myself perceived also that one event happeneth to them all.",
  },
  {
    reference: 'MATTHEW 12:1',
    referenceURL: 'https://www.bible.com/bible/1/mat.12.1.KJV',
    verseText:
      'At that time Jesus went on the sabbath day through the corn; and his disciples were an hungred, and began to pluck the ears of corn, and to eat.',
  },
  {
    reference: 'JOB 1:22',
    referenceURL: 'https://www.bible.com/bible/1/JOB.1.22.KJV',
    verseText: 'In all this Job sinned not, nor charged God foolishly.',
  },
  {
    reference: 'GENESIS 28:5',
    referenceURL: 'https://www.bible.com/bible/1/GEN.28.5.KJV',
    verseText:
      "And Isaac sent away Jacob: and he went to Padan-aram unto Laban, son of Bethuel the Syrian, the brother of Rebekah, Jacob's and Esau's mother.",
  },
  {
    reference: 'PSALM 69:8',
    referenceURL: 'https://www.bible.com/bible/1/PSA.69.8.KJV',
    verseText:
      "I am become a stranger unto my brethren, And an alien unto my mother's children.",
  },
  {
    reference: 'HEBREWS 12:1',
    referenceURL: 'https://www.bible.com/bible/1/HEB.12.1.KJV',
    verseText:
      'Wherefore seeing we also are compassed about with so great a cloud of witnesses, let us lay aside every weight, and the sin which doth so easily beset us, and let us run with patience the race that is set before us',
  },
  {
    reference: 'LUKE 2:16',
    referenceURL: 'https://www.bible.com/bible/1/LUK.2.16.KJV',
    verseText:
      'And they came with haste, and found Mary, and Joseph, and the babe lying in a manger.',
  },
  {
    reference: 'JOHN 15:15',
    referenceURL: 'https://www.bible.com/bible/1/JHN.15.15.KJV',
    verseText:
      'Henceforth I call you not servants; for the servant knoweth not what his lord doeth: but I have called you friends; for all things that I have heard of my Father I have made known unto you.',
  },
  {
    reference: '1 JOHN 5:21',
    referenceURL: 'https://www.bible.com/bible/1/1JO.5.21.KJV',
    verseText: 'Little children, keep yourselves from idols. Amen.',
  },
  {
    reference: 'REVELATION 14:2',
    referenceURL: 'https://www.bible.com/bible/1/REV.14.2.KJV',
    verseText:
      'And I heard a voice from heaven, as the voice of many waters, and as the voice of a great thunder: and I heard the voice of harpers harping with their harps',
  },
  {
    reference: 'PROVERBS 15:3',
    referenceURL: 'https://www.bible.com/bible/1/PRO.15.3.KJV',
    verseText:
      'The eyes of the LORD are in every place, Beholding the evil and the good.',
  },
  {
    reference: 'LUKE 22:42',
    referenceURL: 'https://www.bible.com/bible/1/LUK.22.42.KJV',
    verseText:
      'saying, Father, if thou be willing, remove this cup from me: nevertheless not my will, but thine, be done.',
  },
  {
    reference: 'MATTHEW 1:21',
    referenceURL: 'https://www.bible.com/bible/1/mat.1.21.KJV',
    verseText:
      'And she shall bring forth a son, and thou shalt call his name JESUS: for he shall save his people from their sins.',
  },
  {
    reference: 'PHILIPPIANS 4:7',
    referenceURL: 'https://www.bible.com/bible/1/PHP.4.7.KJV',
    verseText:
      'And the peace of God, which passeth all understanding, shall keep your hearts and minds through Christ Jesus.',
  },
  {
    reference: 'JUDGES 3:22',
    referenceURL: 'https://www.bible.com/bible/1/JDG.3.22.KJV',
    verseText:
      'and the haft also went in after the blade; and the fat closed upon the blade, so that he could not draw the dagger out of his belly; and the dirt came out.',
  },
  {
    reference: 'GENESIS 17:19',
    referenceURL: 'https://www.bible.com/bible/1/GEN.17.19.KJV',
    verseText:
      'And God said, Sarah thy wife shall bear thee a son indeed; and thou shalt call his name Isaac: and I will establish my covenant with him for an everlasting covenant, and with his seed after him.',
  },
  {
    reference: 'JAMES 1:27',
    referenceURL: 'https://www.bible.com/bible/1/JAS.1.27.KJV',
    verseText:
      'Pure religion and undefiled before God and the Father is this, To visit the fatherless and widows in their affliction, and to keep himself unspotted from the world.',
  },
  {
    reference: 'REVELATION 20:12',
    referenceURL: 'https://www.bible.com/bible/1/REV.20.12.KJV',
    verseText:
      'And I saw the dead, small and great, stand before God; and the books were opened: and another book was opened, which is the book of life: and the dead were judged out of those things which were written in the books, according to their works.',
  },
  {
    reference: 'MATTHEW 19:29',
    referenceURL: 'https://www.bible.com/bible/1/mat.19.29.KJV',
    verseText:
      "And every one that hath forsaken houses, or brethren, or sisters, or father, or mother, or wife, or children, or lands, for my name's sake, shall receive an hundredfold, and shall inherit everlasting life.",
  },
  {
    reference: 'ISAIAH 53:4',
    referenceURL: 'https://www.bible.com/bible/1/ISA.53.4.KJV',
    verseText:
      'Surely he hath borne our griefs, and carried our sorrows: yet we did esteem him stricken, smitten of God, and afflicted.',
  },
  {
    reference: 'LUKE 10:3',
    referenceURL: 'https://www.bible.com/bible/1/LUK.10.3.KJV',
    verseText: 'Go your ways: behold, I send you forth as lambs among wolves.',
  },
  {
    reference: 'ISAIAH 53:9',
    referenceURL: 'https://www.bible.com/bible/1/ISA.53.9.KJV',
    verseText:
      'And he made his grave with the wicked, and with the rich in his death; because he had done no violence, neither was any deceit in his mouth.',
  },
  {
    reference: 'ESTHER 2:17',
    referenceURL: 'https://www.bible.com/bible/1/EST.2.17.KJV',
    verseText:
      'And the king loved Esther above all the women, and she obtained grace and favour in his sight more than all the virgins; so that he set the royal crown upon her head, and made her queen instead of Vashti.',
  },
  {
    reference: 'LUKE 5:11',
    referenceURL: 'https://www.bible.com/bible/1/LUK.5.11.KJV',
    verseText:
      'And when they had brought their ships to land, they forsook all, and followed him.',
  },
  {
    reference: 'PROVERBS 1:7',
    referenceURL: 'https://www.bible.com/bible/1/PRO.1.7.KJV',
    verseText:
      'The fear of the LORD is the beginning of knowledge: But fools despise wisdom and instruction.',
  },
  {
    reference: 'PROVERBS 31:30',
    referenceURL: 'https://www.bible.com/bible/1/PRO.31.30.KJV',
    verseText:
      'Favour is deceitful, and beauty is vain: But a woman that feareth the LORD, she shall be praised.',
  },
  {
    reference: 'EXODUS 15:18',
    referenceURL: 'https://www.bible.com/bible/1/EXO.15.18.KJV',
    verseText: 'The LORD shall reign for ever and ever.',
  },
  {
    reference: 'PSALM 40:17',
    referenceURL: 'https://www.bible.com/bible/1/PSA.40.17.KJV',
    verseText:
      'But I am poor and needy; Yet the Lord thinketh upon me: Thou art my help and my deliverer; Make no tarrying, O my God.',
  },
  {
    reference: 'PROVERBS 25:11',
    referenceURL: 'https://www.bible.com/bible/1/PRO.25.11.KJV',
    verseText:
      'A word fitly spoken Is like apples of gold in pictures of silver.',
  },
  {
    reference: 'PSALM 91:11',
    referenceURL: 'https://www.bible.com/bible/1/psa.91.11.KJV',
    verseText:
      'For he shall give his angels charge over thee, To keep thee in all thy ways.',
  },
  {
    reference: 'JOHN 3:36',
    referenceURL: 'https://www.bible.com/bible/1/JHN.3.36.KJV',
    verseText:
      'He that believeth on the Son hath everlasting life: and he that believeth not the Son shall not see life; but the wrath of God abideth on him.',
  },
  {
    reference: '2 TIMOTHY 3:12',
    referenceURL: 'https://www.bible.com/bible/1/2ti.3.12.KJV',
    verseText:
      'Yea, and all that will live godly in Christ Jesus shall suffer persecution.',
  },
  {
    reference: 'GENESIS 1:27',
    referenceURL: 'https://www.bible.com/bible/1/GEN.1.27.KJV',
    verseText:
      'So God created man in his own image, in the image of God created he him; male and female created he them.',
  },
  {
    reference: 'GENESIS 8:22',
    referenceURL: 'https://www.bible.com/bible/1/GEN.8.22.KJV',
    verseText:
      'While the earth remaineth, seedtime and harvest, and cold and heat, and summer and winter, and day and night shall not cease.',
  },
  {
    reference: 'JOHN 7:24',
    referenceURL: 'https://www.bible.com/bible/1/JHN.7.24.KJV',
    verseText:
      'Judge not according to the appearance, but judge righteous judgment.',
  },
  {
    reference: 'PROVERBS 1:14',
    referenceURL: 'https://www.bible.com/bible/1/PRO.1.14.KJV',
    verseText: 'Cast in thy lot among us; Let us all have one purse',
  },
  {
    reference: '1 THESSALONIANS 5:23',
    referenceURL: 'https://www.bible.com/bible/1/1TH.5.23.KJV',
    verseText:
      'And the very God of peace sanctify you wholly; and I pray God your whole spirit and soul and body be preserved blameless unto the coming of our Lord Jesus Christ.',
  },
  {
    reference: 'ROMANS 8:33',
    referenceURL: 'https://www.bible.com/bible/1/ROM.8.33.KJV',
    verseText:
      "Who shall lay any thing to the charge of God's elect? It is God that justifieth.",
  },
  {
    reference: 'JAMES 1:2',
    referenceURL: 'https://www.bible.com/bible/1/JAS.1.2.KJV',
    verseText:
      'My brethren, count it all joy when ye fall into divers temptations',
  },
  {
    reference: 'PSALM 59:16',
    referenceURL: 'https://www.bible.com/bible/1/psa.59.16.KJV',
    verseText:
      'But I will sing of thy power; Yea, I will sing aloud of thy mercy in the morning: For thou hast been my defence and refuge in the day of my trouble.',
  },
  {
    reference: 'MATTHEW 18:15',
    referenceURL: 'https://www.bible.com/bible/1/MAT.18.15.KJV',
    verseText:
      'Moreover if thy brother shall trespass against thee, go and tell him his fault between thee and him alone: if he shall hear thee, thou hast gained thy brother.',
  },
  {
    reference: 'JOHN 19:39',
    referenceURL: 'https://www.bible.com/bible/1/JHN.19.39.KJV',
    verseText:
      'And there came also Nicodemus, which at the first came to Jesus by night, and brought a mixture of myrrh and aloes, about an hundred pound weight.',
  },
  {
    reference: '2 TIMOTHY 1:7',
    referenceURL: 'https://www.bible.com/bible/1/2TI.1.7.KJV',
    verseText:
      'For God hath not given us the spirit of fear; but of power, and of love, and of a sound mind.',
  },
  {
    reference: 'ACTS 13:22',
    referenceURL: 'https://www.bible.com/bible/1/ACT.13.22.KJV',
    verseText:
      'And when he had removed him, he raised up unto them David to be their king; to whom also he gave testimony, and said, I have found David the son of Jesse, a man after mine own heart, which shall fulfil all my will.',
  },
  {
    reference: 'PROVERBS 20:15',
    referenceURL: 'https://www.bible.com/bible/1/PRO.20.15.KJV',
    verseText:
      'There is gold, and a multitude of rubies: But the lips of knowledge are a precious jewel.',
  },
  {
    reference: 'JOHN 4:14',
    referenceURL: 'https://www.bible.com/bible/1/JHN.4.14.KJV',
    verseText:
      'but whosoever drinketh of the water that I shall give him shall never thirst; but the water that I shall give him shall be in him a well of water springing up into everlasting life.',
  },
  {
    reference: 'JOHN 6:15',
    referenceURL: 'https://www.bible.com/bible/1/JHN.6.15.KJV',
    verseText:
      'When Jesus therefore perceived that they would come and take him by force, to make him a king, he departed again into a mountain himself alone.',
  },
  {
    reference: '1 JOHN 4:7',
    referenceURL: 'https://www.bible.com/bible/1/1JN.4.7.KJV',
    verseText:
      'Beloved, let us love one another: for love is of God; and every one that loveth is born of God, and knoweth God.',
  },
  {
    reference: 'JONAH 3:6',
    referenceURL: 'https://www.bible.com/bible/1/JON.3.6.KJV',
    verseText:
      'For word came unto the king of Nineveh, and he arose from his throne, and he laid his robe from him, and covered him with sackcloth, and sat in ashes.',
  },
  {
    reference: '1 TIMOTHY 6:10',
    referenceURL: 'https://www.bible.com/bible/1/1TI.6.10.KJV',
    verseText:
      'For the love of money is the root of all evil: which while some coveted after, they have erred from the faith, and pierced themselves through with many sorrows.',
  },
  {
    reference: 'MATTHEW 9:13',
    referenceURL: 'https://www.bible.com/bible/1/MAT.9.13.KJV',
    verseText:
      'But go ye and learn what that meaneth, I will have mercy, and not sacrifice: for I am not come to call the righteous, but sinners to repentance.',
  },
  {
    reference: 'ACTS 3:6',
    referenceURL: 'https://www.bible.com/bible/1/ACT.3.6.KJV',
    verseText:
      'Then Peter said, Silver and gold have I none; but such as I have give I thee: In the name of Jesus Christ of Nazareth rise up and walk.',
  },
  {
    reference: 'COLOSSIANS 2:8',
    referenceURL: 'https://www.bible.com/bible/1/COL.2.8.KJV',
    verseText:
      'Beware lest any man spoil you through philosophy and vain deceit, after the tradition of men, after the rudiments of the world, and not after Christ.',
  },
  {
    reference: 'GENESIS 40:5',
    referenceURL: 'https://www.bible.com/bible/1/gen.40.5.KJV',
    verseText:
      'And they dreamed a dream both of them, each man his dream in one night, each man according to the interpretation of his dream, the butler and the baker of the king of Egypt, which were bound in the prison.',
  },
  {
    reference: 'PSALM 23:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.23.2.KJV',
    verseText:
      'He maketh me to lie down in green pastures: He leadeth me beside the still waters.',
  },
  {
    reference: 'ESTHER 7:6',
    referenceURL: 'https://www.bible.com/bible/1/EST.7.6.KJV',
    verseText:
      'And Esther said, The adversary and enemy is this wicked Haman. Then Haman was afraid before the king and the queen.',
  },
  {
    reference: 'PSALM 73:24',
    referenceURL: 'https://www.bible.com/bible/1/PSA.73.24.KJV',
    verseText:
      'Thou shalt guide me with thy counsel, And afterward receive me to glory.',
  },
  {
    reference: 'RUTH 2:2',
    referenceURL: 'https://www.bible.com/bible/1/RUT.2.2.KJV',
    verseText:
      'And Ruth the Moabitess said unto Naomi, Let me now go to the field, and glean ears of corn after him in whose sight I shall find grace. And she said unto her, Go, my daughter.',
  },
  {
    reference: 'GENESIS 30:13',
    referenceURL: 'https://www.bible.com/bible/1/GEN.30.13.KJV',
    verseText:
      'And Leah said, Happy am I, for the daughters will call me blessed: and she called his name Asher.',
  },
  {
    reference: '1 CORINTHIANS 15:10',
    referenceURL: 'https://www.bible.com/bible/1/1CO.15.10.KJV',
    verseText:
      'But by the grace of God I am what I am: and his grace which was bestowed upon me was not in vain; but I laboured more abundantly than they all: yet not I, but the grace of God which was with me.',
  },
  {
    reference: 'PSALM 106:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.106.2.KJV',
    verseText:
      'Who can utter the mighty acts of the LORD? Who can shew forth all his praise?',
  },
  {
    reference: 'PROVERBS 15:1',
    referenceURL: 'https://www.bible.com/bible/1/PRO.15.1.KJV',
    verseText:
      'A soft answer turneth away wrath: But grievous words stir up anger.',
  },
  {
    reference: 'MATTHEW 5:39',
    referenceURL: 'https://www.bible.com/bible/1/MAT.5.39.KJV',
    verseText:
      'but I say unto you, That ye resist not evil: but whosoever shall smite thee on thy right cheek, turn to him the other also.',
  },
  {
    reference: 'PSALM 119:96',
    referenceURL: 'https://www.bible.com/bible/1/PSA.119.96.KJV',
    verseText:
      'I have seen an end of all perfection: But thy commandment is exceeding broad.',
  },
  {
    reference: 'MATTHEW 25:32',
    referenceURL: 'https://www.bible.com/bible/1/MAT.25.32.KJV',
    verseText:
      'and before him shall be gathered all nations: and he shall separate them one from another, as a shepherd divideth his sheep from the goats',
  },
  {
    reference: 'GENESIS 22:6',
    referenceURL: 'https://www.bible.com/bible/1/GEN.22.6.KJV',
    verseText:
      'And Abraham took the wood of the burnt offering, and laid it upon Isaac his son; and he took the fire in his hand, and a knife; and they went both of them together.',
  },
  {
    reference: 'JONAH 1:17',
    referenceURL: 'https://www.bible.com/bible/1/JON.1.17.KJV',
    verseText:
      'Now the LORD had prepared a great fish to swallow up Jonah. And Jonah was in the belly of the fish three days and three nights.',
  },
  {
    reference: 'DANIEL 3:26',
    referenceURL: 'https://www.bible.com/bible/1/DAN.3.26.KJV',
    verseText:
      'Then Nebuchadnezzar came near to the mouth of the burning fiery furnace, and spake, and said, Shadrach, Meshach, and Abed-nego, ye servants of the most high God, come forth, and come hither. Then Shadrach, Meshach, and Abed-nego, came forth of the midst of the fire.',
  },
  {
    reference: 'JOHN 12:6',
    referenceURL: 'https://www.bible.com/bible/1/JHN.12.6.KJV',
    verseText:
      'This he said, not that he cared for the poor; but because he was a thief, and had the bag, and bare what was put therein.',
  },
  {
    reference: 'PSALM 146:9',
    referenceURL: 'https://www.bible.com/bible/1/PSA.146.9.KJV',
    verseText:
      'The LORD preserveth the strangers; He relieveth the fatherless and widow: But the way of the wicked he turneth upside down.',
  },
  {
    reference: 'MATTHEW 14:26',
    referenceURL: 'https://www.bible.com/bible/1/MAT.14.26.KJV',
    verseText:
      'And when the disciples saw him walking on the sea, they were troubled, saying, It is a spirit; and they cried out for fear.',
  },
  {
    reference: '2 TIMOTHY 4:7',
    referenceURL: 'https://www.bible.com/bible/1/2TI.4.7.KJV',
    verseText:
      'I have fought a good fight, I have finished my course, I have kept the faith',
  },
  {
    reference: 'PROVERBS 5:22',
    referenceURL: 'https://www.bible.com/bible/1/PRO.5.22.KJV',
    verseText:
      'His own iniquities shall take the wicked himself, And he shall be holden with the cords of his sins.',
  },
  {
    reference: 'GENESIS 37:9',
    referenceURL: 'https://www.bible.com/bible/1/GEN.37.9.KJV',
    verseText:
      'And he dreamed yet another dream, and told it his brethren, and said, Behold, I have dreamed a dream more; and, behold, the sun and the moon and the eleven stars made obeisance to me.',
  },
  {
    reference: 'EPHESIANS 5:18',
    referenceURL: 'https://www.bible.com/bible/1/EPH.5.18.KJV',
    verseText:
      'And be not drunk with wine, wherein is excess; but be filled with the Spirit',
  },
  {
    reference: 'NUMBERS 6:24',
    referenceURL: 'https://www.bible.com/bible/1/num.6.24.KJV',
    verseText: 'The LORD bless thee, and keep thee',
  },
  {
    reference: 'REVELATION 21:18',
    referenceURL: 'https://www.bible.com/bible/1/REV.21.18.KJV',
    verseText:
      'And the building of the wall of it was of jasper: and the city was pure gold, like unto clear glass.',
  },
  {
    reference: 'MATTHEW 9:21',
    referenceURL: 'https://www.bible.com/bible/1/mat.9.21.KJV',
    verseText:
      'for she said within herself, If I may but touch his garment, I shall be whole.',
  },
  {
    reference: 'PROVERBS 19:11',
    referenceURL: 'https://www.bible.com/bible/1/PRO.19.11.KJV',
    verseText:
      'The discretion of a man deferreth his anger; And it is his glory to pass over a transgression.',
  },
  {
    reference: 'JOHN 5:18',
    referenceURL: 'https://www.bible.com/bible/1/JHN.5.18.KJV',
    verseText:
      'Therefore the Jews sought the more to kill him, because he not only had broken the sabbath, but said also that God was his Father, making himself equal with God.',
  },
  {
    reference: 'JONAH 3:10',
    referenceURL: 'https://www.bible.com/bible/1/JON.3.10.KJV',
    verseText:
      'And God saw their works, that they turned from their evil way; and God repented of the evil, that he had said that he would do unto them; and he did it not.',
  },
  {
    reference: 'MATTHEW 16:26',
    referenceURL: 'https://www.bible.com/bible/1/MAT.16.26.KJV',
    verseText:
      'For what is a man profited, if he shall gain the whole world, and lose his own soul? or what shall a man give in exchange for his soul?',
  },
  {
    reference: 'JOHN 1:41',
    referenceURL: 'https://www.bible.com/bible/1/JHN.1.41.KJV',
    verseText:
      'He first findeth his own brother Simon, and saith unto him, We have found the Messias, which is, being interpreted, the Christ.',
  },
  {
    reference: 'ACTS 2:17',
    referenceURL: 'https://www.bible.com/bible/1/ACT.2.17.KJV',
    verseText:
      'And it shall come to pass in the last days, saith God, I will pour out of my Spirit upon all flesh: And your sons and your daughters shall prophesy, And your young men shall see visions, And your old men shall dream dreams',
  },
  {
    reference: 'MATTHEW 16:18',
    referenceURL: 'https://www.bible.com/bible/1/MAT.16.18.KJV',
    verseText:
      'And I say also unto thee, That thou art Peter, and upon this rock I will build my church; and the gates of hell shall not prevail against it.',
  },
  {
    reference: 'JOHN 3:16',
    referenceURL: 'https://www.bible.com/bible/1/jhn.3.16.KJV',
    verseText:
      'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.',
  },
  {
    reference: 'DEUTERONOMY 32:39',
    referenceURL: 'https://www.bible.com/bible/1/DEU.32.39.KJV',
    verseText:
      'See now that I, even I, am he, And there is no god with me: I kill, and I make alive; I wound, and I heal: Neither is there any that can deliver out of my hand.',
  },
  {
    reference: 'GENESIS 1:1',
    referenceURL: 'https://www.bible.com/bible/1/GEN.1.1.KJV',
    verseText: 'In the beginning God created the heaven and the earth.',
  },
  {
    reference: 'GENESIS 2:18',
    referenceURL: 'https://www.bible.com/bible/1/GEN.2.18.KJV',
    verseText:
      'And the LORD God said, It is not good that the man should be alone; I will make him an help meet for him.',
  },
  {
    reference: 'COLOSSIANS 3:1',
    referenceURL: 'https://www.bible.com/bible/1/COL.3.1.KJV',
    verseText:
      'If ye then be risen with Christ, seek those things which are above, where Christ sitteth on the right hand of God.',
  },
  {
    reference: 'MATTHEW 11:29',
    referenceURL: 'https://www.bible.com/bible/1/mat.11.29.KJV',
    verseText:
      'Take my yoke upon you, and learn of me; for I am meek and lowly in heart: and ye shall find rest unto your souls.',
  },
  {
    reference: 'MARK 10:25',
    referenceURL: 'https://www.bible.com/bible/1/MRK.10.25.KJV',
    verseText:
      'It is easier for a camel to go through the eye of a needle, than for a rich man to enter into the kingdom of God.',
  },
  {
    reference: 'JOB 41:18',
    referenceURL: 'https://www.bible.com/bible/1/JOB.41.18.KJV',
    verseText:
      'By his neesings a light doth shine, And his eyes are like the eyelids of the morning.',
  },
  {
    reference: 'PROVERBS 12:22',
    referenceURL: 'https://www.bible.com/bible/1/PRO.12.22.KJV',
    verseText:
      'Lying lips are abomination to the LORD: But they that deal truly are his delight.',
  },
  {
    reference: 'REVELATION 22:13',
    referenceURL: 'https://www.bible.com/bible/1/REV.22.13.KJV',
    verseText:
      'I am Alpha and Omega, the beginning and the end, the first and the last.',
  },
  {
    reference: 'EPHESIANS 4:26',
    referenceURL: 'https://www.bible.com/bible/1/EPH.4.26.KJV',
    verseText:
      'Be ye angry, and sin not: let not the sun go down upon your wrath',
  },
  {
    reference: 'GENESIS 32:28',
    referenceURL: 'https://www.bible.com/bible/1/GEN.32.28.KJV',
    verseText:
      'And he said, Thy name shall be called no more Jacob, but Israel: for as a prince hast thou power with God and with men, and hast prevailed.',
  },
  {
    reference: 'GENESIS 40:5',
    referenceURL: 'https://www.bible.com/bible/1/GEN.40.5.KJV',
    verseText:
      'And they dreamed a dream both of them, each man his dream in one night, each man according to the interpretation of his dream, the butler and the baker of the king of Egypt, which were bound in the prison.',
  },
  {
    reference: 'EXODUS 33:22',
    referenceURL: 'https://www.bible.com/bible/1/EXO.33.22.KJV',
    verseText:
      'and it shall come to pass, while my glory passeth by, that I will put thee in a clift of the rock, and will cover thee with my hand while I pass by',
  },
  {
    reference: 'MARK 8:36',
    referenceURL: 'https://www.bible.com/bible/1/MRK.8.36.KJV',
    verseText:
      'For what shall it profit a man, if he shall gain the whole world, and lose his own soul?',
  },
  {
    reference: 'LUKE 12:35',
    referenceURL: 'https://www.bible.com/bible/1/LUK.12.35.KJV',
    verseText: 'Let your loins be girded about, and your lights burning',
  },
  {
    reference: 'PSALM 92:12',
    referenceURL: 'https://www.bible.com/bible/1/PSA.92.12.KJV',
    verseText:
      'The righteous shall flourish like the palm tree: He shall grow like a cedar in Lebanon.',
  },
  {
    reference: 'PSALM 13:6',
    referenceURL: 'https://www.bible.com/bible/1/PSA.13.6.KJV',
    verseText:
      'I will sing unto the LORD, because he hath dealt bountifully with me.',
  },
  {
    reference: 'ISAIAH 40:8',
    referenceURL: 'https://www.bible.com/bible/1/ISA.40.8.KJV',
    verseText:
      'The grass withereth, the flower fadeth: but the word of our God shall stand for ever.',
  },
  {
    reference: 'PSALM 34:18',
    referenceURL: 'https://www.bible.com/bible/1/psa.34.18.KJV',
    verseText:
      'The LORD is nigh unto them that are of a broken heart; And saveth such as be of a contrite spirit.',
  },
  {
    reference: 'GALATIANS 6:9',
    referenceURL: 'https://www.bible.com/bible/1/GAL.6.9.KJV',
    verseText:
      'And let us not be weary in well doing: for in due season we shall reap, if we faint not.',
  },
  {
    reference: 'PSALM 77:20',
    referenceURL: 'https://www.bible.com/bible/1/psa.77.20.KJV',
    verseText:
      'Thou leddest thy people like a flock By the hand of Moses and Aaron.',
  },
  {
    reference: 'HEBREWS 11:30',
    referenceURL: 'https://www.bible.com/bible/1/HEB.11.30.KJV',
    verseText:
      'By faith the walls of Jericho fell down, after they were compassed about seven days.',
  },
  {
    reference: 'HEBREWS 10:14',
    referenceURL: 'https://www.bible.com/bible/1/HEB.10.14.KJV',
    verseText:
      'For by one offering he hath perfected for ever them that are sanctified.',
  },
  {
    reference: 'GENESIS 4:21',
    referenceURL: 'https://www.bible.com/bible/1/GEN.4.21.KJV',
    verseText:
      "And his brother's name was Jubal: he was the father of all such as handle the harp and organ.",
  },
  {
    reference: 'MARK 14:56',
    referenceURL: 'https://www.bible.com/bible/1/MRK.14.56.KJV',
    verseText:
      'For many bare false witness against him, but their witness agreed not together.',
  },
  {
    reference: 'MATTHEW 11:28',
    referenceURL: 'https://www.bible.com/bible/1/MAT.11.28.KJV',
    verseText:
      'Come unto me, all ye that labour and are heavy laden, and I will give you rest.',
  },
  {
    reference: 'MATTHEW 5:36',
    referenceURL: 'https://www.bible.com/bible/1/MAT.5.36.KJV',
    verseText:
      'Neither shalt thou swear by thy head, because thou canst not make one hair white or black.',
  },
  {
    reference: 'ROMANS 11:36',
    referenceURL: 'https://www.bible.com/bible/1/rom.11.36.KJV',
    verseText:
      'For of him, and through him, and to him, are all things: to whom be glory for ever. Amen.',
  },
  {
    reference: 'MARK 4:41',
    referenceURL: 'https://www.bible.com/bible/1/MRK.4.41.KJV',
    verseText:
      'And they feared exceedingly, and said one to another, What manner of man is this, that even the wind and the sea obey him?',
  },
  {
    reference: 'PSALM 104:20',
    referenceURL: 'https://www.bible.com/bible/1/PSA.104.20.KJV',
    verseText:
      'Thou makest darkness, and it is night: Wherein all the beasts of the forest do creep forth.',
  },
  {
    reference: 'PHILIPPIANS 2:5',
    referenceURL: 'https://www.bible.com/bible/1/PHP.2.5.KJV',
    verseText: 'Let this mind be in you, which was also in Christ Jesus',
  },
  {
    reference: 'LUKE 22:48',
    referenceURL: 'https://www.bible.com/bible/1/LUK.22.48.KJV',
    verseText:
      'But Jesus said unto him, Judas, betrayest thou the Son of man with a kiss?',
  },
  {
    reference: 'TITUS 3:9',
    referenceURL: 'https://www.bible.com/bible/1/TIT.3.9.KJV',
    verseText:
      'But avoid foolish questions, and genealogies, and contentions, and strivings about the law; for they are unprofitable and vain.',
  },
  {
    reference: 'EXODUS 1:8',
    referenceURL: 'https://www.bible.com/bible/1/EXO.1.8.KJV',
    verseText:
      'Now there arose up a new king over Egypt, which knew not Joseph.',
  },
  {
    reference: 'JOHN 1:27',
    referenceURL: 'https://www.bible.com/bible/1/jhn.1.27.KJV',
    verseText:
      "he it is, who coming after me is preferred before me, whose shoe's latchet I am not worthy to unloose.",
  },
  {
    reference: 'PSALM 106:2',
    referenceURL: 'https://www.bible.com/bible/1/psa.106.2.KJV',
    verseText:
      'Who can utter the mighty acts of the LORD? Who can shew forth all his praise?',
  },
  {
    reference: 'GENESIS 11:9',
    referenceURL: 'https://www.bible.com/bible/1/GEN.11.9.KJV',
    verseText:
      'Therefore is the name of it called Babel; because the LORD did there confound the language of all the earth: and from thence did the LORD scatter them abroad upon the face of all the earth.',
  },
  {
    reference: '1 CORINTHIANS 13:12',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.12.KJV',
    verseText:
      'For now we see through a glass, darkly; but then face to face: now I know in part; but then shall I know even as also I am known.',
  },
  {
    reference: 'PROVERBS 22:15',
    referenceURL: 'https://www.bible.com/bible/1/PRO.22.15.KJV',
    verseText:
      'Foolishness is bound in the heart of a child; But the rod of correction shall drive it far from him.',
  },
  {
    reference: 'EXODUS 16:14',
    referenceURL: 'https://www.bible.com/bible/1/EXO.16.14.KJV',
    verseText:
      'And when the dew that lay was gone up, behold, upon the face of the wilderness there lay a small round thing, as small as the hoar frost on the ground.',
  },
  {
    reference: 'JAMES 1:22',
    referenceURL: 'https://www.bible.com/bible/1/JAS.1.22.KJV',
    verseText:
      'But be ye doers of the word, and not hearers only, deceiving your own selves.',
  },
  {
    reference: 'MATTHEW 18:12',
    referenceURL: 'https://www.bible.com/bible/1/mat.18.12.KJV',
    verseText:
      'How think ye? if a man have an hundred sheep, and one of them be gone astray, doth he not leave the ninety and nine, and goeth into the mountains, and seeketh that which is gone astray?',
  },
  {
    reference: 'MATTHEW 14:31',
    referenceURL: 'https://www.bible.com/bible/1/MAT.14.31.KJV',
    verseText:
      'And immediately Jesus stretched forth his hand, and caught him, and said unto him, O thou of little faith, wherefore didst thou doubt?',
  },
  {
    reference: 'EXODUS 3:2',
    referenceURL: 'https://www.bible.com/bible/1/EXO.3.2.KJV',
    verseText:
      'And the angel of the LORD appeared unto him in a flame of fire out of the midst of a bush: and he looked, and, behold, the bush burned with fire, and the bush was not consumed.',
  },
  {
    reference: 'ROMANS 15:12',
    referenceURL: 'https://www.bible.com/bible/1/ROM.15.12.KJV',
    verseText:
      'And again, Esaias saith, There shall be a root of Jesse, And he that shall rise to reign over the Gentiles; In him shall the Gentiles trust.',
  },
  {
    reference: 'PROVERBS 29:11',
    referenceURL: 'https://www.bible.com/bible/1/PRO.29.11.KJV',
    verseText:
      'A fool uttereth all his mind: But a wise man keepeth it in till afterwards.',
  },
  {
    reference: 'ROMANS 8:39',
    referenceURL: 'https://www.bible.com/bible/1/ROM.8.39.KJV',
    verseText:
      'nor height, nor depth, nor any other creature, shall be able to separate us from the love of God, which is in Christ Jesus our Lord.',
  },
  {
    reference: 'DEUTERONOMY 10:17',
    referenceURL: 'https://www.bible.com/bible/1/DEU.10.17.KJV',
    verseText:
      'For the LORD your God is God of gods, and Lord of lords, a great God, a mighty, and a terrible, which regardeth not persons, nor taketh reward',
  },
  {
    reference: 'MATTHEW 6:26',
    referenceURL: 'https://www.bible.com/bible/1/MAT.6.26.KJV',
    verseText:
      'Behold the fowls of the air: for they sow not, neither do they reap, nor gather into barns; yet your heavenly Father feedeth them. Are ye not much better than they?',
  },
  {
    reference: 'PSALM 86:11',
    referenceURL: 'https://www.bible.com/bible/1/PSA.86.11.KJV',
    verseText:
      'Teach me thy way, O LORD; I will walk in thy truth: Unite my heart to fear thy name.',
  },
  {
    reference: 'ROMANS 6:23',
    referenceURL: 'https://www.bible.com/bible/1/ROM.6.23.KJV',
    verseText:
      'For the wages of sin is death; but the gift of God is eternal life through Jesus Christ our Lord.',
  },
  {
    reference: 'LUKE 2:10',
    referenceURL: 'https://www.bible.com/bible/1/LUK.2.10.KJV',
    verseText:
      'And the angel said unto them, Fear not: for, behold, I bring you good tidings of great joy, which shall be to all people.',
  },
  {
    reference: '1 CORINTHIANS 1:18',
    referenceURL: 'https://www.bible.com/bible/1/1CO.1.18.KJV',
    verseText:
      'For the preaching of the cross is to them that perish foolishness; but unto us which are saved it is the power of God.',
  },
  {
    reference: 'LUKE 9:23',
    referenceURL: 'https://www.bible.com/bible/1/LUK.9.23.KJV',
    verseText:
      'And he said to them all, If any man will come after me, let him deny himself, and take up his cross daily, and follow me.',
  },
  {
    reference: 'EXODUS 9:11',
    referenceURL: 'https://www.bible.com/bible/1/EXO.9.11.KJV',
    verseText:
      'And the magicians could not stand before Moses because of the boils; for the boil was upon the magicians, and upon all the Egyptians.',
  },
  {
    reference: 'PROVERBS 29:20',
    referenceURL: 'https://www.bible.com/bible/1/PRO.29.20.KJV',
    verseText:
      'Seest thou a man that is hasty in his words? There is more hope of a fool than of him.',
  },
  {
    reference: 'PSALM 145:3',
    referenceURL: 'https://www.bible.com/bible/1/PSA.145.3.KJV',
    verseText:
      'Great is the LORD, and greatly to be praised; And his greatness is unsearchable.',
  },
  {
    reference: 'HEBREWS 11:1',
    referenceURL: 'https://www.bible.com/bible/1/HEB.11.1.KJV',
    verseText:
      'Now faith is the substance of things hoped for, the evidence of things not seen.',
  },
  {
    reference: 'HEBREWS 2:9',
    referenceURL: 'https://www.bible.com/bible/1/HEB.2.9.KJV',
    verseText:
      'But we see Jesus, who was made a little lower than the angels for the suffering of death, crowned with glory and honour; that he by the grace of God should taste death for every man.',
  },
  {
    reference: 'REVELATION 20:1',
    referenceURL: 'https://www.bible.com/bible/1/REV.20.1.KJV',
    verseText:
      'And I saw an angel come down from heaven, having the key of the bottomless pit and a great chain in his hand.',
  },
  {
    reference: 'JOHN 9:25',
    referenceURL: 'https://www.bible.com/bible/1/JHN.9.25.KJV',
    verseText:
      'He answered and said, Whether he be a sinner or no, I know not: one thing I know, that, whereas I was blind, now I see.',
  },
  {
    reference: 'JEREMIAH 2:13',
    referenceURL: 'https://www.bible.com/bible/1/JER.2.13.KJV',
    verseText:
      'For my people have committed two evils; they have forsaken me the fountain of living waters, and hewed them out cisterns, broken cisterns, that can hold no water.',
  },
  {
    reference: 'GENESIS 2:23',
    referenceURL: 'https://www.bible.com/bible/1/GEN.2.23.KJV',
    verseText:
      'And Adam said, This is now bone of my bones, and flesh of my flesh: she shall be called Woman, because she was taken out of Man.',
  },
  {
    reference: 'MATTHEW 3:4',
    referenceURL: 'https://www.bible.com/bible/1/MAT.3.4.KJV',
    verseText:
      "And the same John had his raiment of camel's hair, and a leathern girdle about his loins; and his meat was locusts and wild honey.",
  },
  {
    reference: 'PSALM 127:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.127.2.KJV',
    verseText:
      'It is vain for you to rise up early, to sit up late, to eat the bread of sorrows: For so he giveth his beloved sleep.',
  },
  {
    reference: '1 KINGS 17:4',
    referenceURL: 'https://www.bible.com/bible/1/1KI.17.4.KJV',
    verseText:
      'And it shall be, that thou shalt drink of the brook; and I have commanded the ravens to feed thee there.',
  },
  {
    reference: 'NUMBERS 13:30',
    referenceURL: 'https://www.bible.com/bible/1/NUM.13.30.KJV',
    verseText:
      'And Caleb stilled the people before Moses, and said, Let us go up at once, and possess it; for we are well able to overcome it.',
  },
  {
    reference: 'LUKE 22:44',
    referenceURL: 'https://www.bible.com/bible/1/LUK.22.44.KJV',
    verseText:
      'And being in an agony he prayed more earnestly: and his sweat was as it were great drops of blood falling down to the ground.',
  },
  {
    reference: 'JOHN 3:14',
    referenceURL: 'https://www.bible.com/bible/1/JHN.3.14.KJV',
    verseText:
      'And as Moses lifted up the serpent in the wilderness, even so must the Son of man be lifted up',
  },
  {
    reference: 'MARK 16:4',
    referenceURL: 'https://www.bible.com/bible/1/MRK.16.4.KJV',
    verseText:
      'And when they looked, they saw that the stone was rolled away: for it was very great.',
  },
  {
    reference: 'ROMANS 11:4',
    referenceURL: 'https://www.bible.com/bible/1/ROM.11.4.KJV',
    verseText:
      'But what saith the answer of God unto him? I have reserved to myself seven thousand men, who have not bowed the knee to the image of Baal.',
  },
  {
    reference: 'DANIEL 6:10',
    referenceURL: 'https://www.bible.com/bible/1/dan.6.10.KJV',
    verseText:
      'Now when Daniel knew that the writing was signed, he went into his house; and his windows being open in his chamber toward Jerusalem, he kneeled upon his knees three times a day, and prayed, and gave thanks before his God, as he did aforetime.',
  },
  {
    reference: 'JOHN 10:27',
    referenceURL: 'https://www.bible.com/bible/1/JHN.10.27.KJV',
    verseText: 'My sheep hear my voice, and I know them, and they follow me',
  },
  {
    reference: 'JOHN 1:3',
    referenceURL: 'https://www.bible.com/bible/1/JHN.1.3.KJV',
    verseText:
      'All things were made by him; and without him was not any thing made that was made.',
  },
  {
    reference: 'PSALM 71:17',
    referenceURL: 'https://www.bible.com/bible/1/PSA.71.17.KJV',
    verseText:
      'O God, thou hast taught me from my youth: And hitherto have I declared thy wondrous works.',
  },
  {
    reference: '1 JOHN 2:12',
    referenceURL: 'https://www.bible.com/bible/1/1JN.2.12.KJV',
    verseText:
      "I write unto you, little children, because your sins are forgiven you for his name's sake.",
  },
  {
    reference: 'MATTHEW 17:20',
    referenceURL: 'https://www.bible.com/bible/1/MAT.17.20.KJV',
    verseText:
      'And Jesus said unto them, Because of your unbelief: for verily I say unto you, If ye have faith as a grain of mustard seed, ye shall say unto this mountain, Remove hence to yonder place; and it shall remove; and nothing shall be impossible unto you.',
  },
  {
    reference: 'PSALM 27:4',
    referenceURL: 'https://www.bible.com/bible/1/PSA.27.4.KJV',
    verseText:
      'One thing have I desired of the LORD, that will I seek after; That I may dwell in the house of the LORD all the days of my life, To behold the beauty of the LORD, and to enquire in his temple.',
  },
  {
    reference: 'ROMANS 8:37',
    referenceURL: 'https://www.bible.com/bible/1/ROM.8.37.KJV',
    verseText:
      'Nay, in all these things we are more than conquerors through him that loved us.',
  },
  {
    reference: 'ISAIAH 25:8',
    referenceURL: 'https://www.bible.com/bible/1/ISA.25.8.KJV',
    verseText:
      'He will swallow up death in victory; and the Lord GOD will wipe away tears from off all faces; and the rebuke of his people shall he take away from off all the earth: for the LORD hath spoken it.',
  },
  {
    reference: 'JOHN 5:24',
    referenceURL: 'https://www.bible.com/bible/1/JHN.5.24.KJV',
    verseText:
      'Verily, verily, I say unto you, He that heareth my word, and believeth on him that sent me, hath everlasting life, and shall not come into condemnation; but is passed from death unto life.',
  },
  {
    reference: 'PHILIPPIANS 4:8',
    referenceURL: 'https://www.bible.com/bible/1/PHP.4.8.KJV',
    verseText:
      'Finally, brethren, whatsoever things are true, whatsoever things are honest, whatsoever things are just, whatsoever things are pure, whatsoever things are lovely, whatsoever things are of good report; if there be any virtue, and if there be any praise, think on these things.',
  },
  {
    reference: 'PHILIPPIANS 4:13',
    referenceURL: 'https://www.bible.com/bible/1/PHP.4.13.KJV',
    verseText: 'I can do all things through Christ which strengtheneth me.',
  },
  {
    reference: 'HEBREWS 3:4',
    referenceURL: 'https://www.bible.com/bible/1/HEB.3.4.KJV',
    verseText:
      'For every house is builded by some man; but he that built all things is God.',
  },
  {
    reference: '1 JOHN 3:16',
    referenceURL: 'https://www.bible.com/bible/1/1JN.3.16.KJV',
    verseText:
      'Hereby perceive we the love of God, because he laid down his life for us: and we ought to lay down our lives for the brethren.',
  },
  {
    reference: 'JOHN 1:1',
    referenceURL: 'https://www.bible.com/bible/1/JHN.1.1.KJV',
    verseText:
      'In the beginning was the Word, and the Word was with God, and the Word was God.',
  },
  {
    reference: 'HEBREWS 4:15',
    referenceURL: 'https://www.bible.com/bible/1/HEB.4.15.KJV',
    verseText:
      'For we have not an high priest which cannot be touched with the feeling of our infirmities; but was in all points tempted like as we are, yet without sin.',
  },
  {
    reference: 'HEBREWS 13:5',
    referenceURL: 'https://www.bible.com/bible/1/HEB.13.5.KJV',
    verseText:
      'Let your conversation be without covetousness; and be content with such things as ye have: for he hath said, I will never leave thee, nor forsake thee.',
  },
  {
    reference: 'ROMANS 3:23',
    referenceURL: 'https://www.bible.com/bible/1/ROM.3.23.KJV',
    verseText: 'for all have sinned, and come short of the glory of God',
  },
  {
    reference: 'PSALM 139:13',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.13.KJV',
    verseText:
      "For thou hast possessed my reins: Thou hast covered me in my mother's womb.",
  },
  {
    reference: 'ISAIAH 45:18',
    referenceURL: 'https://www.bible.com/bible/1/ISA.45.18.KJV',
    verseText:
      'For thus saith the LORD that created the heavens; God himself that formed the earth and made it; he hath established it, he created it not in vain, he formed it to be inhabited: I am the LORD; and there is none else.',
  },
  {
    reference: '1 CORINTHIANS 10:13',
    referenceURL: 'https://www.bible.com/bible/1/1CO.10.13.KJV',
    verseText:
      'There hath no temptation taken you but such as is common to man: but God is faithful, who will not suffer you to be tempted above that ye are able; but will with the temptation also make a way to escape, that ye may be able to bear it.',
  },
  {
    reference: 'PSALM 49:15',
    referenceURL: 'https://www.bible.com/bible/1/PSA.49.15.KJV',
    verseText:
      'But God will redeem my soul from the power of the grave: For he shall receive me. Selah.',
  },
  {
    reference: 'PROVERBS 4:3',
    referenceURL: 'https://www.bible.com/bible/1/PRO.4.3.KJV',
    verseText:
      "For I was my father's son, Tender and only beloved in the sight of my mother.",
  },
  {
    reference: 'REVELATION 21:4',
    referenceURL: 'https://www.bible.com/bible/1/REV.21.4.KJV',
    verseText:
      'And God shall wipe away all tears from their eyes; and there shall be no more death, neither sorrow, nor crying, neither shall there be any more pain: for the former things are passed away.',
  },
  {
    reference: 'PSALM 133:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.133.1.KJV',
    verseText:
      'Behold, how good and how pleasant it is For brethren to dwell together in unity!',
  },
  {
    reference: 'JOHN 11:25',
    referenceURL: 'https://www.bible.com/bible/1/JHN.11.25.KJV',
    verseText:
      'Jesus said unto her, I am the resurrection, and the life: he that believeth in me, though he were dead, yet shall he live',
  },
  {
    reference: 'HEBREWS 4:16',
    referenceURL: 'https://www.bible.com/bible/1/HEB.4.16.KJV',
    verseText:
      'Let us therefore come boldly unto the throne of grace, that we may obtain mercy, and find grace to help in time of need.',
  },
  {
    reference: 'ISAIAH 41:10',
    referenceURL: 'https://www.bible.com/bible/1/ISA.41.10.KJV',
    verseText:
      'Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness.',
  },
  {
    reference: '2 CORINTHIANS 12:9',
    referenceURL: 'https://www.bible.com/bible/1/2CO.12.9.KJV',
    verseText:
      'And he said unto me, My grace is sufficient for thee: for my strength is made perfect in weakness. Most gladly therefore will I rather glory in my infirmities, that the power of Christ may rest upon me.',
  },
  {
    reference: '2 CORINTHIANS 5:7',
    referenceURL: 'https://www.bible.com/bible/1/2CO.5.7.KJV',
    verseText: '(for we walk by faith, not by sight:)',
  },
  {
    reference: 'JOHN 14:27',
    referenceURL: 'https://www.bible.com/bible/1/JHN.14.27.KJV',
    verseText:
      'Peace I leave with you, my peace I give unto you: not as the world giveth, give I unto you. Let not your heart be troubled, neither let it be afraid.',
  },
  {
    reference: 'COLOSSIANS 3:23',
    referenceURL: 'https://www.bible.com/bible/1/COL.3.23.KJV',
    verseText:
      'and whatsoever ye do, do it heartily, as to the Lord, and not unto men',
  },
  {
    reference: 'JOHN 13:35',
    referenceURL: 'https://www.bible.com/bible/1/JHN.13.35.KJV',
    verseText:
      'By this shall all men know that ye are my disciples, if ye have love one to another.',
  },
  {
    reference: 'PSALM 89:11',
    referenceURL: 'https://www.bible.com/bible/1/PSA.89.11.KJV',
    verseText:
      'The heavens are thine, the earth also is thine: As for the world and the fulness thereof, thou hast founded them.',
  },
  {
    reference: 'ROMANS 10:9',
    referenceURL: 'https://www.bible.com/bible/1/ROM.10.9.KJV',
    verseText:
      'that if thou shalt confess with thy mouth the Lord Jesus, and shalt believe in thine heart that God hath raised him from the dead, thou shalt be saved.',
  },
  {
    reference: 'ROMANS 8:38',
    referenceURL: 'https://www.bible.com/bible/1/ROM.8.38.KJV',
    verseText:
      'For I am persuaded, that neither death, nor life, nor angels, nor principalities, nor powers, nor things present, nor things to come',
  },
  {
    reference: 'HEBREWS 4:12',
    referenceURL: 'https://www.bible.com/bible/1/HEB.4.12.KJV',
    verseText:
      'For the word of God is quick, and powerful, and sharper than any twoedged sword, piercing even to the dividing asunder of soul and spirit, and of the joints and marrow, and is a discerner of the thoughts and intents of the heart.',
  },
  {
    reference: 'HEBREWS 10:25',
    referenceURL: 'https://www.bible.com/bible/1/HEB.10.25.KJV',
    verseText:
      'not forsaking the assembling of ourselves together, as the manner of some is; but exhorting one another: and so much the more, as ye see the day approaching.',
  },
  {
    reference: 'MATTHEW 22:37',
    referenceURL: 'https://www.bible.com/bible/1/MAT.22.37.KJV',
    verseText:
      'Jesus said unto him, Thou shalt love the Lord thy God with all thy heart, and with all thy soul, and with all thy mind.',
  },
  {
    reference: 'PHILIPPIANS 4:6',
    referenceURL: 'https://www.bible.com/bible/1/PHP.4.6.KJV',
    verseText:
      'Be careful for nothing; but in every thing by prayer and supplication with thanksgiving let your requests be made known unto God.',
  },
  {
    reference: 'PSALM 71:5',
    referenceURL: 'https://www.bible.com/bible/1/PSA.71.5.KJV',
    verseText:
      'For thou art my hope, O Lord GOD: Thou art my trust from my youth.',
  },
  {
    reference: 'JOHN 6:47',
    referenceURL: 'https://www.bible.com/bible/1/JHN.6.47.KJV',
    verseText:
      'Verily, verily, I say unto you, He that believeth on me hath everlasting life.',
  },
  {
    reference: 'JOHN 6:39',
    referenceURL: 'https://www.bible.com/bible/1/JHN.6.39.KJV',
    verseText:
      "And this is the Father's will which hath sent me, that of all which he hath given me I should lose nothing, but should raise it up again at the last day.",
  },
  {
    reference: '1 JOHN 2:17',
    referenceURL: 'https://www.bible.com/bible/1/1JN.2.17.KJV',
    verseText:
      'And the world passeth away, and the lust thereof: but he that doeth the will of God abideth for ever.',
  },
  {
    reference: 'PSALM 19:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.19.1.KJV',
    verseText:
      'The heavens declare the glory of God; And the firmament sheweth his handywork.',
  },
  {
    reference: 'ACTS 1:8',
    referenceURL: 'https://www.bible.com/bible/1/ACT.1.8.KJV',
    verseText:
      'But ye shall receive power, after that the Holy Ghost is come upon you: and ye shall be witnesses unto me both in Jerusalem, and in all Jud\u00e6a, and in Samaria, and unto the uttermost part of the earth.',
  },
  {
    reference: 'PHILIPPIANS 1:6',
    referenceURL: 'https://www.bible.com/bible/1/PHP.1.6.KJV',
    verseText:
      'being confident of this very thing, that he which hath begun a good work in you will perform it until the day of Jesus Christ',
  },
  {
    reference: '1 PETER 5:7',
    referenceURL: 'https://www.bible.com/bible/1/1PE.5.7.KJV',
    verseText: 'casting all your care upon him; for he careth for you.',
  },
  {
    reference: 'ROMANS 10:17',
    referenceURL: 'https://www.bible.com/bible/1/ROM.10.17.KJV',
    verseText:
      'So then faith cometh by hearing, and hearing by the word of God.',
  },
  {
    reference: 'JOHN 15:13',
    referenceURL: 'https://www.bible.com/bible/1/JHN.15.13.KJV',
    verseText:
      'Greater love hath no man than this, that a man lay down his life for his friends.',
  },
  {
    reference: 'MARK 11:22',
    referenceURL: 'https://www.bible.com/bible/1/MRK.11.22.KJV',
    verseText: 'And Jesus answering saith unto them, Have faith in God.',
  },
  {
    reference: 'GALATIANS 2:20',
    referenceURL: 'https://www.bible.com/bible/1/GAL.2.20.KJV',
    verseText:
      'I am crucified with Christ: nevertheless I live; yet not I, but Christ liveth in me: and the life which I now live in the flesh I live by the faith of the Son of God, who loved me, and gave himself for me.',
  },
  {
    reference: 'ROMANS 15:13',
    referenceURL: 'https://www.bible.com/bible/1/ROM.15.13.KJV',
    verseText:
      'Now the God of hope fill you with all joy and peace in believing, that ye may abound in hope, through the power of the Holy Ghost.',
  },
  {
    reference: '1 CORINTHIANS 6:19',
    referenceURL: 'https://www.bible.com/bible/1/1CO.6.19.KJV',
    verseText:
      'What? know ye not that your body is the temple of the Holy Ghost which is in you, which ye have of God, and ye are not your own?',
  },
  {
    reference: 'ACTS 4:12',
    referenceURL: 'https://www.bible.com/bible/1/ACT.4.12.KJV',
    verseText:
      'Neither is there salvation in any other: for there is none other name under heaven given among men, whereby we must be saved.',
  },
  {
    reference: 'ROMANS 5:1',
    referenceURL: 'https://www.bible.com/bible/1/ROM.5.1.KJV',
    verseText:
      'Therefore being justified by faith, we have peace with God through our Lord Jesus Christ',
  },
  {
    reference: 'ECCLESIASTES 3:11',
    referenceURL: 'https://www.bible.com/bible/1/ECC.3.11.KJV',
    verseText:
      'He hath made every thing beautiful in his time: also he hath set the world in their heart, so that no man can find out the work that God maketh from the beginning to the end.',
  },
  {
    reference: 'ISAIAH 26:3',
    referenceURL: 'https://www.bible.com/bible/1/ISA.26.3.KJV',
    verseText:
      'Thou wilt keep him in perfect peace, whose mind is stayed on thee: because he trusteth in thee.',
  },
  {
    reference: 'REVELATION 7:17',
    referenceURL: 'https://www.bible.com/bible/1/REV.7.17.KJV',
    verseText:
      'For the Lamb which is in the midst of the throne shall feed them, and shall lead them unto living fountains of waters: and God shall wipe away all tears from their eyes.',
  },
  {
    reference: 'NEHEMIAH 9:6',
    referenceURL: 'https://www.bible.com/bible/1/NEH.9.6.KJV',
    verseText:
      'Thou, even thou, art LORD alone; thou hast made heaven, the heaven of heavens, with all their host, the earth, and all things that are therein, the seas, and all that is therein, and thou preservest them all; and the host of heaven worshippeth thee.',
  },
  {
    reference: 'JOSHUA 1:8',
    referenceURL: 'https://www.bible.com/bible/1/JOS.1.8.KJV',
    verseText:
      'This book of the law shall not depart out of thy mouth; but thou shalt meditate therein day and night, that thou mayest observe to do according to all that is written therein: for then thou shalt make thy way prosperous, and then thou shalt have good success.',
  },
  {
    reference: 'JOHN 1:12',
    referenceURL: 'https://www.bible.com/bible/1/JHN.1.12.KJV',
    verseText:
      'But as many as received him, to them gave he power to become the sons of God, even to them that believe on his name',
  },
  {
    reference: 'PSALM 147:3',
    referenceURL: 'https://www.bible.com/bible/1/PSA.147.3.KJV',
    verseText: 'He healeth the broken in heart, And bindeth up their wounds.',
  },
  {
    reference: 'PHILIPPIANS 4:19',
    referenceURL: 'https://www.bible.com/bible/1/PHP.4.19.KJV',
    verseText:
      'But my God shall supply all your need according to his riches in glory by Christ Jesus.',
  },
  {
    reference: '2 CORINTHIANS 5:21',
    referenceURL: 'https://www.bible.com/bible/1/2CO.5.21.KJV',
    verseText:
      'For he hath made him to be sin for us, who knew no sin; that we might be made the righteousness of God in him.',
  },
  {
    reference: 'EPHESIANS 3:21',
    referenceURL: 'https://www.bible.com/bible/1/EPH.3.21.KJV',
    verseText:
      'unto him be glory in the church by Christ Jesus throughout all ages, world without end. Amen.',
  },
  {
    reference: 'HEBREWS 10:24',
    referenceURL: 'https://www.bible.com/bible/1/HEB.10.24.KJV',
    verseText:
      'and let us consider one another to provoke unto love and to good works',
  },
  {
    reference: 'MICAH 6:8',
    referenceURL: 'https://www.bible.com/bible/1/MIC.6.8.KJV',
    verseText:
      'He hath shewed thee, O man, what is good; and what doth the LORD require of thee, but to do justly, and to love mercy, and to walk humbly with thy God?',
  },
  {
    reference: 'JOSHUA 1:9',
    referenceURL: 'https://www.bible.com/bible/1/JOS.1.9.KJV',
    verseText:
      'Have not I commanded thee? Be strong and of a good courage; be not afraid, neither be thou dismayed: for the LORD thy God is with thee whithersoever thou goest.',
  },
  {
    reference: '1 PETER 5:4',
    referenceURL: 'https://www.bible.com/bible/1/1PE.5.4.KJV',
    verseText:
      'And when the chief Shepherd shall appear, ye shall receive a crown of glory that fadeth not away.',
  },
  {
    reference: 'ISAIAH 55:8',
    referenceURL: 'https://www.bible.com/bible/1/ISA.55.8.KJV',
    verseText:
      'For my thoughts are not your thoughts, neither are your ways my ways, saith the LORD.',
  },
  {
    reference: 'EPHESIANS 2:8',
    referenceURL: 'https://www.bible.com/bible/1/EPH.2.8.KJV',
    verseText:
      'For by grace are ye saved through faith; and that not of yourselves: it is the gift of God',
  },
  {
    reference: '1 TIMOTHY 4:12',
    referenceURL: 'https://www.bible.com/bible/1/1TI.4.12.KJV',
    verseText:
      'Let no man despise thy youth; but be thou an example of the believers, in word, in conversation, in charity, in spirit, in faith, in purity.',
  },
  {
    reference: 'PROVERBS 3:5',
    referenceURL: 'https://www.bible.com/bible/1/PRO.3.5.KJV',
    verseText:
      'Trust in the LORD with all thine heart; And lean not unto thine own understanding.',
  },
  {
    reference: 'EPHESIANS 3:20',
    referenceURL: 'https://www.bible.com/bible/1/EPH.3.20.KJV',
    verseText:
      'Now unto him that is able to do exceeding abundantly above all that we ask or think, according to the power that worketh in us',
  },
  {
    reference: 'JEREMIAH 32:17',
    referenceURL: 'https://www.bible.com/bible/1/JER.32.17.KJV',
    verseText:
      'Ah Lord GOD! behold, thou hast made the heaven and the earth by thy great power and stretched out arm, and there is nothing too hard for thee',
  },
  {
    reference: '1 PETER 3:15',
    referenceURL: 'https://www.bible.com/bible/1/1PE.3.15.KJV',
    verseText:
      'but sanctify the Lord God in your hearts: and be ready always to give an answer to every man that asketh you a reason of the hope that is in you with meekness and fear',
  },
  {
    reference: 'PSALM 22:10',
    referenceURL: 'https://www.bible.com/bible/1/PSA.22.10.KJV',
    verseText:
      "I was cast upon thee from the womb: Thou art my God from my mother's belly.",
  },
  {
    reference: 'JOHN 14:6',
    referenceURL: 'https://www.bible.com/bible/1/JHN.14.6.KJV',
    verseText:
      'Jesus saith unto him, I am the way, the truth, and the life: no man cometh unto the Father, but by me.',
  },
  {
    reference: 'MARK 10:13',
    referenceURL: 'https://www.bible.com/bible/1/MRK.10.13.KJV',
    verseText:
      'And they brought young children to him, that he should touch them: and his disciples rebuked those that brought them.',
  },
  {
    reference: 'ISAIAH 40:31',
    referenceURL: 'https://www.bible.com/bible/1/ISA.40.31.KJV',
    verseText:
      'but they that wait upon the LORD shall renew their strength; they shall mount up with wings as eagles; they shall run, and not be weary; and they shall walk, and not faint.',
  },
  {
    reference: '1 JOHN 5:4',
    referenceURL: 'https://www.bible.com/bible/1/1JN.5.4.KJV',
    verseText:
      'For whatsoever is born of God overcometh the world: and this is the victory that overcometh the world, even our faith.',
  },
  {
    reference: 'ISAIAH 61:3',
    referenceURL: 'https://www.bible.com/bible/1/ISA.61.3.KJV',
    verseText:
      'to appoint unto them that mourn in Zion, to give unto them beauty for ashes, the oil of joy for mourning, the garment of praise for the spirit of heaviness; that they might be called trees of righteousness, the planting of the LORD, that he might be glorified.',
  },
  {
    reference: 'PSALM 116:15',
    referenceURL: 'https://www.bible.com/bible/1/PSA.116.15.KJV',
    verseText: 'Precious in the sight of the LORD is the death of his saints.',
  },
  {
    reference: 'PSALM 126:5',
    referenceURL: 'https://www.bible.com/bible/1/PSA.126.5.KJV',
    verseText: 'They that sow in tears Shall reap in joy.',
  },
  {
    reference: '1 JOHN 1:9',
    referenceURL: 'https://www.bible.com/bible/1/1JN.1.9.KJV',
    verseText:
      'If we confess our sins, he is faithful and just to forgive us our sins, and to cleanse us from all unrighteousness.',
  },
  {
    reference: 'JEREMIAH 29:11',
    referenceURL: 'https://www.bible.com/bible/1/JER.29.11.KJV',
    verseText:
      'For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end.',
  },
  {
    reference: 'JOHN 16:33',
    referenceURL: 'https://www.bible.com/bible/1/JHN.16.33.KJV',
    verseText:
      'These things I have spoken unto you, that in me ye might have peace. In the world ye shall have tribulation: but be of good cheer; I have overcome the world.',
  },
  {
    reference: 'GENESIS 1:26',
    referenceURL: 'https://www.bible.com/bible/1/GEN.1.26.KJV',
    verseText:
      'And God said, Let us make man in our image, after our likeness: and let them have dominion over the fish of the sea, and over the fowl of the air, and over the cattle, and over all the earth, and over every creeping thing that creepeth upon the earth.',
  },
  {
    reference: '1 PETER 2:24',
    referenceURL: 'https://www.bible.com/bible/1/1PE.2.24.KJV',
    verseText:
      'who his own self bare our sins in his own body on the tree, that we, being dead to sins, should live unto righteousness: by whose stripes ye were healed.',
  },
  {
    reference: 'ROMANS 8:28',
    referenceURL: 'https://www.bible.com/bible/1/ROM.8.28.KJV',
    verseText:
      'And we know that all things work together for good to them that love God, to them who are the called according to his purpose.',
  },
  {
    reference: 'PSALM 119:73',
    referenceURL: 'https://www.bible.com/bible/1/PSA.119.73.KJV',
    verseText:
      'Thy hands have made me and fashioned me: Give me understanding, that I may learn thy commandments.',
  },
  {
    reference: 'GALATIANS 5:22',
    referenceURL: 'https://www.bible.com/bible/1/GAL.5.22.KJV',
    verseText:
      'But the fruit of the Spirit is love, joy, peace, longsuffering, gentleness, goodness, faith',
  },
  {
    reference: 'JAMES 5:16',
    referenceURL: 'https://www.bible.com/bible/1/JAS.5.16.KJV',
    verseText:
      'Confess your faults one to another, and pray one for another, that ye may be healed. The effectual fervent prayer of a righteous man availeth much.',
  },
  {
    reference: 'ROMANS 12:5',
    referenceURL: 'https://www.bible.com/bible/1/ROM.12.5.KJV',
    verseText:
      'so we, being many, are one body in Christ, and every one members one of another.',
  },
  {
    reference: 'PSALM 139:16',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.16.KJV',
    verseText:
      'Thine eyes did see my substance, yet being unperfect; And in thy book all my members were written, Which in continuance were fashioned, When as yet there was none of them.',
  },
  {
    reference: '1 PETER 2:9',
    referenceURL: 'https://www.bible.com/bible/1/1PE.2.9.KJV',
    verseText:
      'But ye are a chosen generation, a royal priesthood, an holy nation, a peculiar people; that ye should shew forth the praises of him who hath called you out of darkness into his marvellous light',
  },
  {
    reference: 'PSALM 91:6',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.6.KJV',
    verseText:
      'Nor for the pestilence that walketh in darkness; Nor for the destruction that wasteth at noonday.',
  },
  {
    reference: 'JEREMIAH 9:24',
    referenceURL: 'https://www.bible.com/bible/1/JER.9.24.KJV',
    verseText:
      'but let him that glorieth glory in this, that he understandeth and knoweth me, that I am the LORD which exercise lovingkindness, judgment, and righteousness, in the earth: for in these things I delight, saith the LORD.',
  },
  {
    reference: 'MATTHEW 6:14',
    referenceURL: 'https://www.bible.com/bible/1/MAT.6.14.KJV',
    verseText:
      'For if ye forgive men their trespasses, your heavenly Father will also forgive you',
  },
  {
    reference: 'LUKE 6:37',
    referenceURL: 'https://www.bible.com/bible/1/LUK.6.37.KJV',
    verseText:
      'Judge not, and ye shall not be judged: condemn not, and ye shall not be condemned: forgive, and ye shall be forgiven',
  },
  {
    reference: '1 JOHN 4:21',
    referenceURL: 'https://www.bible.com/bible/1/1JN.4.21.KJV',
    verseText:
      'And this commandment have we from him, That he who loveth God love his brother also.',
  },
  {
    reference: 'PSALM 91:16',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.16.KJV',
    verseText: 'With long life will I satisfy him, And shew him my salvation.',
  },
  {
    reference: 'COLOSSIANS 3:12',
    referenceURL: 'https://www.bible.com/bible/1/COL.3.12.KJV',
    verseText:
      'Put on therefore, as the elect of God, holy and beloved, bowels of mercies, kindness, humbleness of mind, meekness, longsuffering',
  },
  {
    reference: 'PSALM 37:16',
    referenceURL: 'https://www.bible.com/bible/1/PSA.37.16.KJV',
    verseText:
      'A little that a righteous man hath is better Than the riches of many wicked.',
  },
  {
    reference: 'PSALM 139:4',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.4.KJV',
    verseText:
      'For there is not a word in my tongue, But, lo, O LORD, thou knowest it altogether.',
  },
  {
    reference: 'PSALM 139:18',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.18.KJV',
    verseText:
      'If I should count them, they are more in number than the sand: When I awake, I am still with thee.',
  },
  {
    reference: 'PSALM 139:14',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.14.KJV',
    verseText:
      'I will praise thee; for I am fearfully and wonderfully made: Marvellous are thy works; And that my soul knoweth right well.',
  },
  {
    reference: 'PSALM 46:10',
    referenceURL: 'https://www.bible.com/bible/1/PSA.46.10.KJV',
    verseText:
      'Be still, and know that I am God: I will be exalted among the heathen, I will be exalted in the earth.',
  },
  {
    reference: 'ISAIAH 64:6',
    referenceURL: 'https://www.bible.com/bible/1/ISA.64.6.KJV',
    verseText:
      'But we are all as an unclean thing, and all our righteousnesses are as filthy rags; and we all do fade as a leaf; and our iniquities, like the wind, have taken us away.',
  },
  {
    reference: '1 TIMOTHY 6:6',
    referenceURL: 'https://www.bible.com/bible/1/1TI.6.6.KJV',
    verseText: 'But godliness with contentment is great gain.',
  },
  {
    reference: 'PSALM 91:9',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.9.KJV',
    verseText:
      'Because thou hast made the LORD, which is my refuge, Even the most High, thy habitation',
  },
  {
    reference: 'ROMANS 11:33',
    referenceURL: 'https://www.bible.com/bible/1/ROM.11.33.KJV',
    verseText:
      'O the depth of the riches both of the wisdom and knowledge of God! how unsearchable are his judgments, and his ways past finding out!',
  },
  {
    reference: 'PSALM 32:8',
    referenceURL: 'https://www.bible.com/bible/1/PSA.32.8.KJV',
    verseText:
      'I will instruct thee and teach thee in the way which thou shalt go: I will guide thee with mine eye.',
  },
  {
    reference: 'PSALM 139:9',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.9.KJV',
    verseText:
      'If I take the wings of the morning, And dwell in the uttermost parts of the sea',
  },
  {
    reference: 'EPHESIANS 1:18',
    referenceURL: 'https://www.bible.com/bible/1/EPH.1.18.KJV',
    verseText:
      'the eyes of your understanding being enlightened; that ye may know what is the hope of his calling, and what the riches of the glory of his inheritance in the saints',
  },
  {
    reference: 'PSALM 91:7',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.7.KJV',
    verseText:
      'A thousand shall fall at thy side, and ten thousand at thy right hand; But it shall not come nigh thee.',
  },
  {
    reference: 'PSALM 91:12',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.12.KJV',
    verseText:
      'They shall bear thee up in their hands, Lest thou dash thy foot against a stone.',
  },
  {
    reference: 'PSALM 34:18',
    referenceURL: 'https://www.bible.com/bible/1/PSA.34.18.KJV',
    verseText:
      'The LORD is nigh unto them that are of a broken heart; And saveth such as be of a contrite spirit.',
  },
  {
    reference: 'MARK 9:41',
    referenceURL: 'https://www.bible.com/bible/1/MRK.9.41.KJV',
    verseText:
      'For whosoever shall give you a cup of water to drink in my name, because ye belong to Christ, verily I say unto you, he shall not lose his reward.',
  },
  {
    reference: 'MALACHI 3:10',
    referenceURL: 'https://www.bible.com/bible/1/MAL.3.10.KJV',
    verseText:
      'Bring ye all the tithes into the storehouse, that there may be meat in mine house, and prove me now herewith, saith the LORD of hosts, if I will not open you the windows of heaven, and pour you out a blessing, that there shall not be room enough to receive it.',
  },
  {
    reference: 'PROVERBS 11:25',
    referenceURL: 'https://www.bible.com/bible/1/PRO.11.25.KJV',
    verseText:
      'The liberal soul shall be made fat: And he that watereth shall be watered also himself.',
  },
  {
    reference: 'PROVERBS 17:17',
    referenceURL: 'https://www.bible.com/bible/1/PRO.17.17.KJV',
    verseText:
      'A friend loveth at all times, And a brother is born for adversity.',
  },
  {
    reference: 'PSALM 91:10',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.10.KJV',
    verseText:
      'There shall no evil befall thee, Neither shall any plague come nigh thy dwelling.',
  },
  {
    reference: 'ACTS 20:35',
    referenceURL: 'https://www.bible.com/bible/1/ACT.20.35.KJV',
    verseText:
      'I have shewed you all things, how that so labouring ye ought to support the weak, and to remember the words of the Lord Jesus, how he said, It is more blessed to give than to receive.',
  },
  {
    reference: 'PSALM 91:14',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.14.KJV',
    verseText:
      'Because he hath set his love upon me, therefore will I deliver him: I will set him on high, because he hath known my name.',
  },
  {
    reference: 'PSALM 103:12',
    referenceURL: 'https://www.bible.com/bible/1/PSA.103.12.KJV',
    verseText:
      'As far as the east is from the west, So far hath he removed our transgressions from us.',
  },
  {
    reference: 'ROMANS 15:5',
    referenceURL: 'https://www.bible.com/bible/1/ROM.15.5.KJV',
    verseText:
      'Now the God of patience and consolation grant you to be likeminded one toward another according to Christ Jesus',
  },
  {
    reference: '1 JOHN 1:7',
    referenceURL: 'https://www.bible.com/bible/1/1JN.1.7.KJV',
    verseText:
      'but if we walk in the light, as he is in the light, we have fellowship one with another, and the blood of Jesus Christ his Son cleanseth us from all sin.',
  },
  {
    reference: '1 JOHN 4:12',
    referenceURL: 'https://www.bible.com/bible/1/1JN.4.12.KJV',
    verseText:
      'No man hath seen God at any time. If we love one another, God dwelleth in us, and his love is perfected in us.',
  },
  {
    reference: 'PSALM 91:8',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.8.KJV',
    verseText:
      'Only with thine eyes shalt thou behold And see the reward of the wicked.',
  },
  {
    reference: 'PSALM 139:5',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.5.KJV',
    verseText:
      'Thou hast beset me behind and before, And laid thine hand upon me.',
  },
  {
    reference: 'MARK 11:25',
    referenceURL: 'https://www.bible.com/bible/1/MRK.11.25.KJV',
    verseText:
      'And when ye stand praying, forgive, if ye have ought against any: that your Father also which is in heaven may forgive you your trespasses.',
  },
  {
    reference: 'PSALM 139:12',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.12.KJV',
    verseText:
      'Yea, the darkness hideth not from thee; But the night shineth as the day: The darkness and the light are both alike to thee.',
  },
  {
    reference: 'PSALM 139:10',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.10.KJV',
    verseText:
      'Even there shall thy hand lead me, And thy right hand shall hold me.',
  },
  {
    reference: 'JEREMIAH 33:8',
    referenceURL: 'https://www.bible.com/bible/1/JER.33.8.KJV',
    verseText:
      'And I will cleanse them from all their iniquity, whereby they have sinned against me; and I will pardon all their iniquities, whereby they have sinned, and whereby they have transgressed against me.',
  },
  {
    reference: 'PSALM 37:25',
    referenceURL: 'https://www.bible.com/bible/1/PSA.37.25.KJV',
    verseText:
      'I have been young, and now am old; Yet have I not seen the righteous forsaken, nor his seed begging bread.',
  },
  {
    reference: '1 CORINTHIANS 9:24',
    referenceURL: 'https://www.bible.com/bible/1/1CO.9.24.KJV',
    verseText:
      'Know ye not that they which run in a race run all, but one receiveth the prize? So run, that ye may obtain.',
  },
  {
    reference: 'PSALM 51:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.51.1.KJV',
    verseText:
      'Have mercy upon me, O God, according to thy lovingkindness: According unto the multitude of thy tender mercies blot out my transgressions.',
  },
  {
    reference: 'JAMES 1:17',
    referenceURL: 'https://www.bible.com/bible/1/JAS.1.17.KJV',
    verseText:
      'Every good gift and every perfect gift is from above, and cometh down from the Father of lights, with whom is no variableness, neither shadow of turning.',
  },
  {
    reference: 'MATTHEW 25:34',
    referenceURL: 'https://www.bible.com/bible/1/MAT.25.34.KJV',
    verseText:
      'Then shall the King say unto them on his right hand, Come, ye blessed of my Father, inherit the kingdom prepared for you from the foundation of the world',
  },
  {
    reference: 'PSALM 37:23',
    referenceURL: 'https://www.bible.com/bible/1/PSA.37.23.KJV',
    verseText:
      'The steps of a good man are ordered by the LORD: And he delighteth in his way.',
  },
  {
    reference: 'PSALM 91:3',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.3.KJV',
    verseText:
      'Surely he shall deliver thee from the snare of the fowler, And from the noisome pestilence.',
  },
  {
    reference: 'PSALM 139:6',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.6.KJV',
    verseText:
      'Such knowledge is too wonderful for me; It is high, I cannot attain unto it.',
  },
  {
    reference: '2 CORINTHIANS 9:6',
    referenceURL: 'https://www.bible.com/bible/1/2CO.9.6.KJV',
    verseText:
      'But this I say, He which soweth sparingly shall reap also sparingly; and he which soweth bountifully shall reap also bountifully.',
  },
  {
    reference: 'ECCLESIASTES 11:1',
    referenceURL: 'https://www.bible.com/bible/1/ECC.11.1.KJV',
    verseText:
      'Cast thy bread upon the waters: for thou shalt find it after many days.',
  },
  {
    reference: 'PSALM 91:11',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.11.KJV',
    verseText:
      'For he shall give his angels charge over thee, To keep thee in all thy ways.',
  },
  {
    reference: 'PSALM 91:5',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.5.KJV',
    verseText:
      'Thou shalt not be afraid for the terror by night; Nor for the arrow that flieth by day',
  },
  {
    reference: 'JOHN 14:12',
    referenceURL: 'https://www.bible.com/bible/1/JHN.14.12.KJV',
    verseText:
      'Verily, verily, I say unto you, He that believeth on me, the works that I do shall he do also; and greater works than these shall he do; because I go unto my Father.',
  },
  {
    reference: 'PSALM 139:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.2.KJV',
    verseText:
      'Thou knowest my downsitting and mine uprising, thou understandest my thought afar off.',
  },
  {
    reference: 'REVELATION 4:11',
    referenceURL: 'https://www.bible.com/bible/1/REV.4.11.KJV',
    verseText:
      'Thou art worthy, O Lord, to receive glory and honour and power: for thou hast created all things, and for thy pleasure they are and were created.',
  },
  {
    reference: 'PSALM 9:18',
    referenceURL: 'https://www.bible.com/bible/1/PSA.9.18.KJV',
    verseText:
      'For the needy shall not alway be forgotten: The expectation of the poor shall not perish for ever.',
  },
  {
    reference: 'PSALM 91:15',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.15.KJV',
    verseText:
      'He shall call upon me, and I will answer him: I will be with him in trouble; I will deliver him, and honour him.',
  },
  {
    reference: 'PSALM 139:3',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.3.KJV',
    verseText:
      'Thou compassest my path and my lying down, And art acquainted with all my ways.',
  },
  {
    reference: 'MATTHEW 6:1',
    referenceURL: 'https://www.bible.com/bible/1/MAT.6.1.KJV',
    verseText:
      'Take heed that ye do not your alms before men, to be seen of them: otherwise ye have no reward of your Father which is in heaven.',
  },
  {
    reference: 'PSALM 91:13',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.13.KJV',
    verseText:
      'Thou shalt tread upon the lion and adder: The young lion and the dragon shalt thou trample under feet.',
  },
  {
    reference: '1 THESSALONIANS 5:11',
    referenceURL: 'https://www.bible.com/bible/1/1TH.5.11.KJV',
    verseText:
      'Wherefore comfort yourselves together, and edify one another, even as also ye do.',
  },
  {
    reference: 'PSALM 73:23',
    referenceURL: 'https://www.bible.com/bible/1/PSA.73.23.KJV',
    verseText:
      'Nevertheless I am continually with thee: Thou hast holden me by my right hand.',
  },
  {
    reference: 'PSALM 139:8',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.8.KJV',
    verseText:
      'If I ascend up into heaven, thou art there: If I make my bed in hell, behold, thou art there.',
  },
  {
    reference: 'PROVERBS 3:6',
    referenceURL: 'https://www.bible.com/bible/1/PRO.3.6.KJV',
    verseText:
      'In all thy ways acknowledge him, And he shall direct thy paths.',
  },
  {
    reference: 'PSALM 139:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.1.KJV',
    verseText: 'O LORD, thou hast searched me, and known me.',
  },
  {
    reference: 'PSALM 145:8',
    referenceURL: 'https://www.bible.com/bible/1/PSA.145.8.KJV',
    verseText:
      'The LORD is gracious, and full of compassion; Slow to anger, and of great mercy.',
  },
  {
    reference: 'MATTHEW 6:11',
    referenceURL: 'https://www.bible.com/bible/1/MAT.6.11.KJV',
    verseText: 'Give us this day our daily bread.',
  },
  {
    reference: 'EPHESIANS 4:32',
    referenceURL: 'https://www.bible.com/bible/1/EPH.4.32.KJV',
    verseText:
      "and be ye kind one to another, tenderhearted, forgiving one another, even as God for Christ's sake hath forgiven you.",
  },
  {
    reference: 'PSALM 92:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.92.1.KJV',
    verseText:
      'It is a good thing to give thanks unto the LORD, And to sing praises unto thy name, O most High',
  },
  {
    reference: 'MATTHEW 6:13',
    referenceURL: 'https://www.bible.com/bible/1/MAT.6.13.KJV',
    verseText:
      'And lead us not into temptation, but deliver us from evil: For thine is the kingdom, and the power, and the glory, for ever. Amen.',
  },
  {
    reference: 'REVELATION 4:8',
    referenceURL: 'https://www.bible.com/bible/1/REV.4.8.KJV',
    verseText:
      'And the four beasts had each of them six wings about him; and they were full of eyes within: and they rest not day and night, saying, Holy, holy, holy, Lord God Almighty, which was, and is, and is to come.',
  },
  {
    reference: 'EPHESIANS 4:1',
    referenceURL: 'https://www.bible.com/bible/1/EPH.4.1.KJV',
    verseText:
      'I therefore, the prisoner of the Lord, beseech you that ye walk worthy of the vocation wherewith ye are called',
  },
  {
    reference: '1 KINGS 8:60',
    referenceURL: 'https://www.bible.com/bible/1/1KI.8.60.KJV',
    verseText:
      'that all the people of the earth may know that the LORD is God, and that there is none else.',
  },
  {
    reference: 'PSALM 139:15',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.15.KJV',
    verseText:
      'My substance was not hid from thee, When I was made in secret, and curiously wrought in the lowest parts of the earth.',
  },
  {
    reference: 'PSALM 139:7',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.7.KJV',
    verseText:
      'Whither shall I go from thy spirit? Or whither shall I flee from thy presence?',
  },
  {
    reference: '1 JOHN 3:17',
    referenceURL: 'https://www.bible.com/bible/1/1JN.3.17.KJV',
    verseText:
      "But whoso hath this world's good, and seeth his brother have need, and shutteth up his bowels of compassion from him, how dwelleth the love of God in him?",
  },
  {
    reference: 'PSALM 139:11',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.11.KJV',
    verseText:
      'If I say, Surely the darkness shall cover me; Even the night shall be light about me.',
  },
  {
    reference: 'ROMANS 13:14',
    referenceURL: 'https://www.bible.com/bible/1/ROM.13.14.KJV',
    verseText:
      'But put ye on the Lord Jesus Christ, and make not provision for the flesh, to fulfil the lusts thereof.',
  },
  {
    reference: 'PSALM 138:8',
    referenceURL: 'https://www.bible.com/bible/1/PSA.138.8.KJV',
    verseText:
      'The LORD will perfect that which concerneth me: Thy mercy, O LORD, endureth for ever: Forsake not the works of thine own hands.',
  },
  {
    reference: 'LUKE 6:38',
    referenceURL: 'https://www.bible.com/bible/1/LUK.6.38.KJV',
    verseText:
      'give, and it shall be given unto you; good measure, pressed down, and shaken together, and running over, shall men give into your bosom. For with the same measure that ye mete withal it shall be measured to you again.',
  },
  {
    reference: 'DEUTERONOMY 7:9',
    referenceURL: 'https://www.bible.com/bible/1/DEU.7.9.KJV',
    verseText:
      'Know therefore that the LORD thy God, he is God, the faithful God, which keepeth covenant and mercy with them that love him and keep his commandments to a thousand generations',
  },
  {
    reference: 'ZEPHANIAH 3:17',
    referenceURL: 'https://www.bible.com/bible/1/ZEP.3.17.KJV',
    verseText:
      'The LORD thy God in the midst of thee is mighty; he will save, he will rejoice over thee with joy; he will rest in his love, he will joy over thee with singing.',
  },
  {
    reference: 'JAMES 4:7',
    referenceURL: 'https://www.bible.com/bible/1/JAS.4.7.KJV',
    verseText:
      'Submit yourselves therefore to God. Resist the devil, and he will flee from you.',
  },
  {
    reference: 'ISAIAH 64:4',
    referenceURL: 'https://www.bible.com/bible/1/ISA.64.4.KJV',
    verseText:
      'For since the beginning of the world men have not heard, nor perceived by the ear, neither hath the eye seen, O God, beside thee, what he hath prepared for him that waiteth for him.',
  },
  {
    reference: 'MATTHEW 6:31',
    referenceURL: 'https://www.bible.com/bible/1/MAT.6.31.KJV',
    verseText:
      'Therefore take no thought, saying, What shall we eat? or, What shall we drink? or, Wherewithal shall we be clothed?',
  },
  {
    reference: 'PSALM 91:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.2.KJV',
    verseText:
      'I will say of the LORD, He is my refuge and my fortress: My God; in him will I trust.',
  },
  {
    reference: 'PSALM 139:17',
    referenceURL: 'https://www.bible.com/bible/1/PSA.139.17.KJV',
    verseText:
      'How precious also are thy thoughts unto me, O God! How great is the sum of them!',
  },
  {
    reference: 'PSALM 91:4',
    referenceURL: 'https://www.bible.com/bible/1/PSA.91.4.KJV',
    verseText:
      'He shall cover thee with his feathers, and under his wings shalt thou trust: His truth shall be thy shield and buckler.',
  },
  {
    reference: 'HEBREWS 13:2',
    referenceURL: 'https://www.bible.com/bible/1/HEB.13.2.KJV',
    verseText:
      'Be not forgetful to entertain strangers: for thereby some have entertained angels unawares.',
  },
  {
    reference: 'ISAIAH 30:29',
    referenceURL: 'https://www.bible.com/bible/1/ISA.30.29.KJV',
    verseText:
      'Ye shall have a song, as in the night when a holy solemnity is kept; and gladness of heart, as when one goeth with a pipe to come into the mountain of the LORD, to the mighty One of Israel.',
  },
  {
    reference: 'EXODUS 20:5',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.5.KJV',
    verseText:
      'thou shalt not bow down thyself to them, nor serve them: for I the LORD thy God am a jealous God, visiting the iniquity of the fathers upon the children unto the third and fourth generation of them that hate me',
  },
  {
    reference: '1 TIMOTHY 2:1',
    referenceURL: 'https://www.bible.com/bible/1/1TI.2.1.KJV',
    verseText:
      'I exhort therefore, that, first of all, supplications, prayers, intercessions, and giving of thanks, be made for all men',
  },
  {
    reference: 'PROVERBS 2:6',
    referenceURL: 'https://www.bible.com/bible/1/PRO.2.6.KJV',
    verseText:
      'For the LORD giveth wisdom: Out of his mouth cometh knowledge and understanding.',
  },
  {
    reference: 'EXODUS 20:6',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.6.KJV',
    verseText:
      'and shewing mercy unto thousands of them that love me, and keep my commandments.',
  },
  {
    reference: 'PROVERBS 6:20',
    referenceURL: 'https://www.bible.com/bible/1/PRO.6.20.KJV',
    verseText:
      "My son, keep thy father's commandment, And forsake not the law of thy mother",
  },
  {
    reference: 'LUKE 6:41',
    referenceURL: 'https://www.bible.com/bible/1/LUK.6.41.KJV',
    verseText:
      "And why beholdest thou the mote that is in thy brother's eye, but perceivest not the beam that is in thine own eye?",
  },
  {
    reference: 'EXODUS 20:9',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.9.KJV',
    verseText: 'Six days shalt thou labour, and do all thy work',
  },
  {
    reference: 'PHILIPPIANS 1:9',
    referenceURL: 'https://www.bible.com/bible/1/PHP.1.9.KJV',
    verseText:
      'And this I pray, that your love may abound yet more and more in knowledge and in all judgment',
  },
  {
    reference: 'PROVERBS 10:19',
    referenceURL: 'https://www.bible.com/bible/1/PRO.10.19.KJV',
    verseText:
      'In the multitude of words there wanteth not sin: But he that refraineth his lips is wise.',
  },
  {
    reference: 'ACTS 16:31',
    referenceURL: 'https://www.bible.com/bible/1/ACT.16.31.KJV',
    verseText:
      'And they said, Believe on the Lord Jesus Christ, and thou shalt be saved, and thy house.',
  },
  {
    reference: 'PROVERBS 3:7',
    referenceURL: 'https://www.bible.com/bible/1/PRO.3.7.KJV',
    verseText:
      'Be not wise in thine own eyes: Fear the LORD, and depart from evil.',
  },
  {
    reference: 'JAMES 3:13',
    referenceURL: 'https://www.bible.com/bible/1/JAS.3.13.KJV',
    verseText:
      'Who is a wise man and endued with knowledge among you? let him shew out of a good conversation his works with meekness of wisdom.',
  },
  {
    reference: '2 CORINTHIANS 4:16',
    referenceURL: 'https://www.bible.com/bible/1/2CO.4.16.KJV',
    verseText:
      'For which cause we faint not; but though our outward man perish, yet the inward man is renewed day by day.',
  },
  {
    reference: 'ROMANS 10:14',
    referenceURL: 'https://www.bible.com/bible/1/ROM.10.14.KJV',
    verseText:
      'How then shall they call on him in whom they have not believed? and how shall they believe in him of whom they have not heard? and how shall they hear without a preacher?',
  },
  {
    reference: 'PROVERBS 13:22',
    referenceURL: 'https://www.bible.com/bible/1/PRO.13.22.KJV',
    verseText:
      "A good man leaveth an inheritance to his children's children: And the wealth of the sinner is laid up for the just.",
  },
  {
    reference: 'ROMANS 10:13',
    referenceURL: 'https://www.bible.com/bible/1/ROM.10.13.KJV',
    verseText:
      'For whosoever shall call upon the name of the Lord shall be saved.',
  },
  {
    reference: 'PSALM 116:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.116.1.KJV',
    verseText:
      'I love the LORD, Because he hath heard my voice and my supplications.',
  },
  {
    reference: 'PSALM 73:25',
    referenceURL: 'https://www.bible.com/bible/1/PSA.73.25.KJV',
    verseText:
      'Whom have I in heaven but thee? And there is none upon earth that I desire beside thee.',
  },
  {
    reference: 'ISAIAH 53:5',
    referenceURL: 'https://www.bible.com/bible/1/ISA.53.5.KJV',
    verseText:
      'But he was wounded for our transgressions, he was bruised for our iniquities: the chastisement of our peace was upon him; and with his stripes we are healed.',
  },
  {
    reference: 'DEUTERONOMY 32:46',
    referenceURL: 'https://www.bible.com/bible/1/DEU.32.46.KJV',
    verseText:
      'and he said unto them, Set your hearts unto all the words which I testify among you this day, which ye shall command your children to observe to do, all the words of this law.',
  },
  {
    reference: 'ECCLESIASTES 4:9',
    referenceURL: 'https://www.bible.com/bible/1/ECC.4.9.KJV',
    verseText:
      'Two are better than one; because they have a good reward for their labour.',
  },
  {
    reference: 'DANIEL 2:44',
    referenceURL: 'https://www.bible.com/bible/1/DAN.2.44.KJV',
    verseText:
      'And in the days of these kings shall the God of heaven set up a kingdom, which shall never be destroyed: and the kingdom shall not be left to other people, but it shall break in pieces and consume all these kingdoms, and it shall stand for ever.',
  },
  {
    reference: 'PROVERBS 8:32',
    referenceURL: 'https://www.bible.com/bible/1/PRO.8.32.KJV',
    verseText:
      'Now therefore hearken unto me, O ye children: For blessed are they that keep my ways.',
  },
  {
    reference: 'PROVERBS 15:1',
    referenceURL: 'https://www.bible.com/bible/1/PRO.15.1.KJV',
    verseText:
      'A soft answer turneth away wrath: But grievous words stir up anger.',
  },
  {
    reference: 'DEUTERONOMY 31:6',
    referenceURL: 'https://www.bible.com/bible/1/DEU.31.6.KJV',
    verseText:
      'Be strong and of a good courage, fear not, nor be afraid of them: for the LORD thy God, he it is that doth go with thee; he will not fail thee, nor forsake thee.',
  },
  {
    reference: 'EPHESIANS 6:10',
    referenceURL: 'https://www.bible.com/bible/1/EPH.6.10.KJV',
    verseText:
      'Finally, my brethren, be strong in the Lord, and in the power of his might.',
  },
  {
    reference: 'HEBREWS 7:25',
    referenceURL: 'https://www.bible.com/bible/1/HEB.7.25.KJV',
    verseText:
      'Wherefore he is able also to save them to the uttermost that come unto God by him, seeing he ever liveth to make intercession for them.',
  },
  {
    reference: 'EPHESIANS 5:25',
    referenceURL: 'https://www.bible.com/bible/1/EPH.5.25.KJV',
    verseText:
      'Husbands, love your wives, even as Christ also loved the church, and gave himself for it',
  },
  {
    reference: 'ROMANS 8:15',
    referenceURL: 'https://www.bible.com/bible/1/ROM.8.15.KJV',
    verseText:
      'For ye have not received the spirit of bondage again to fear; but ye have received the Spirit of adoption, whereby we cry, Abba, Father.',
  },
  {
    reference: 'PSALM 55:22',
    referenceURL: 'https://www.bible.com/bible/1/PSA.55.22.KJV',
    verseText:
      'Cast thy burden upon the LORD, and he shall sustain thee: He shall never suffer the righteous to be moved.',
  },
  {
    reference: '2 CHRONICLES 7:14',
    referenceURL: 'https://www.bible.com/bible/1/2CH.7.14.KJV',
    verseText:
      'if my people, which are called by my name, shall humble themselves, and pray, and seek my face, and turn from their wicked ways; then will I hear from heaven, and will forgive their sin, and will heal their land.',
  },
  {
    reference: 'EPHESIANS 5:22',
    referenceURL: 'https://www.bible.com/bible/1/EPH.5.22.KJV',
    verseText:
      'Wives, submit yourselves unto your own husbands, as unto the Lord.',
  },
  {
    reference: 'PSALM 145:18',
    referenceURL: 'https://www.bible.com/bible/1/PSA.145.18.KJV',
    verseText:
      'The LORD is nigh unto all them that call upon him, To all that call upon him in truth.',
  },
  {
    reference: 'HEBREWS 6:10',
    referenceURL: 'https://www.bible.com/bible/1/HEB.6.10.KJV',
    verseText:
      'For God is not unrighteous to forget your work and labour of love, which ye have shewed toward his name, in that ye have ministered to the saints, and do minister.',
  },
  {
    reference: 'EXODUS 20:15',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.15.KJV',
    verseText: 'Thou shalt not steal.',
  },
  {
    reference: 'PROVERBS 29:17',
    referenceURL: 'https://www.bible.com/bible/1/PRO.29.17.KJV',
    verseText:
      'Correct thy son, and he shall give thee rest; Yea, he shall give delight unto thy soul.',
  },
  {
    reference: 'JOHN 17:3',
    referenceURL: 'https://www.bible.com/bible/1/JHN.17.3.KJV',
    verseText:
      'And this is life eternal, that they might know thee the only true God, and Jesus Christ, whom thou hast sent.',
  },
  {
    reference: 'PSALM 89:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.89.1.KJV',
    verseText:
      'I will sing of the mercies of the LORD for ever: With my mouth will I make known thy faithfulness to all generations.',
  },
  {
    reference: 'PHILIPPIANS 3:20',
    referenceURL: 'https://www.bible.com/bible/1/PHP.3.20.KJV',
    verseText:
      'For our conversation is in heaven; from whence also we look for the Saviour, the Lord Jesus Christ',
  },
  {
    reference: '1 CORINTHIANS 13:2',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.2.KJV',
    verseText:
      'And though I have the gift of prophecy, and understand all mysteries, and all knowledge; and though I have all faith, so that I could remove mountains, and have not charity, I am nothing.',
  },
  {
    reference: 'PSALM 18:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.18.1.KJV',
    verseText: 'I will love thee, O LORD, my strength.',
  },
  {
    reference: 'MATTHEW 28:18',
    referenceURL: 'https://www.bible.com/bible/1/MAT.28.18.KJV',
    verseText:
      'And Jesus came and spake unto them, saying, All power is given unto me in heaven and in earth.',
  },
  {
    reference: '2 CORINTHIANS 4:18',
    referenceURL: 'https://www.bible.com/bible/1/2CO.4.18.KJV',
    verseText:
      'while we look not at the things which are seen, but at the things which are not seen: for the things which are seen are temporal; but the things which are not seen are eternal.',
  },
  {
    reference: 'EXODUS 20:8',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.8.KJV',
    verseText: 'Remember the sabbath day, to keep it holy.',
  },
  {
    reference: '1 CORINTHIANS 15:51',
    referenceURL: 'https://www.bible.com/bible/1/1CO.15.51.KJV',
    verseText:
      'Behold, I shew you a mystery; We shall not all sleep, but we shall all be changed',
  },
  {
    reference: 'JOHN 15:9',
    referenceURL: 'https://www.bible.com/bible/1/JHN.15.9.KJV',
    verseText:
      'As the Father hath loved me, so have I loved you: continue ye in my love.',
  },
  {
    reference: 'PROVERBS 16:7',
    referenceURL: 'https://www.bible.com/bible/1/PRO.16.7.KJV',
    verseText:
      "When a man's ways please the LORD, He maketh even his enemies to be at peace with him.",
  },
  {
    reference: 'PHILIPPIANS 2:6',
    referenceURL: 'https://www.bible.com/bible/1/PHP.2.6.KJV',
    verseText:
      'who, being in the form of God, thought it not robbery to be equal with God',
  },
  {
    reference: 'PROVERBS 22:15',
    referenceURL: 'https://www.bible.com/bible/1/PRO.22.15.KJV',
    verseText:
      'Foolishness is bound in the heart of a child; But the rod of correction shall drive it far from him.',
  },
  {
    reference: 'COLOSSIANS 4:2',
    referenceURL: 'https://www.bible.com/bible/1/COL.4.2.KJV',
    verseText: 'Continue in prayer, and watch in the same with thanksgiving',
  },
  {
    reference: 'PSALM 145:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.145.1.KJV',
    verseText:
      'I will extol thee, my God, O King; And I will bless thy name for ever and ever.',
  },
  {
    reference: '1 CORINTHIANS 7:3',
    referenceURL: 'https://www.bible.com/bible/1/1CO.7.3.KJV',
    verseText:
      'Let the husband render unto the wife due benevolence: and likewise also the wife unto the husband.',
  },
  {
    reference: 'LUKE 11:10',
    referenceURL: 'https://www.bible.com/bible/1/LUK.11.10.KJV',
    verseText:
      'For every one that asketh receiveth; and he that seeketh findeth; and to him that knocketh it shall be opened.',
  },
  {
    reference: 'HEBREWS 13:6',
    referenceURL: 'https://www.bible.com/bible/1/HEB.13.6.KJV',
    verseText:
      'So that we may boldly say, The Lord is my helper, and I will not fear What man shall do unto me.',
  },
  {
    reference: 'EPHESIANS 1:16',
    referenceURL: 'https://www.bible.com/bible/1/EPH.1.16.KJV',
    verseText:
      'cease not to give thanks for you, making mention of you in my prayers',
  },
  {
    reference: '2 CHRONICLES 15:7',
    referenceURL: 'https://www.bible.com/bible/1/2CH.15.7.KJV',
    verseText:
      'Be ye strong therefore, and let not your hands be weak: for your work shall be rewarded.',
  },
  {
    reference: 'LUKE 10:2',
    referenceURL: 'https://www.bible.com/bible/1/LUK.10.2.KJV',
    verseText:
      'Therefore said he unto them, The harvest truly is great, but the labourers are few: pray ye therefore the Lord of the harvest, that he would send forth labourers into his harvest.',
  },
  {
    reference: 'DEUTERONOMY 5:33',
    referenceURL: 'https://www.bible.com/bible/1/DEU.5.33.KJV',
    verseText:
      'Ye shall walk in all the ways which the LORD your God hath commanded you, that ye may live, and that it may be well with you, and that ye may prolong your days in the land which ye shall possess.',
  },
  {
    reference: 'PROVERBS 9:10',
    referenceURL: 'https://www.bible.com/bible/1/PRO.9.10.KJV',
    verseText:
      'The fear of the LORD is the beginning of wisdom: And the knowledge of the holy is understanding.',
  },
  {
    reference: 'ISAIAH 59:21',
    referenceURL: 'https://www.bible.com/bible/1/ISA.59.21.KJV',
    verseText:
      "As for me, this is my covenant with them, saith the LORD; My spirit that is upon thee, and my words which I have put in thy mouth, shall not depart out of thy mouth, nor out of the mouth of thy seed, nor out of the mouth of thy seed's seed, saith the LORD, from henceforth and for ever.",
  },
  {
    reference: 'PROVERBS 20:11',
    referenceURL: 'https://www.bible.com/bible/1/PRO.20.11.KJV',
    verseText:
      'Even a child is known by his doings, Whether his work be pure, and whether it be right.',
  },
  {
    reference: 'PROVERBS 17:6',
    referenceURL: 'https://www.bible.com/bible/1/PRO.17.6.KJV',
    verseText:
      "Children's children are the crown of old men; And the glory of children are their fathers.",
  },
  {
    reference: 'PSALM 90:12',
    referenceURL: 'https://www.bible.com/bible/1/PSA.90.12.KJV',
    verseText:
      'So teach us to number our days, That we may apply our hearts unto wisdom.',
  },
  {
    reference: 'PROVERBS 15:5',
    referenceURL: 'https://www.bible.com/bible/1/PRO.15.5.KJV',
    verseText:
      "A fool despiseth his father's instruction: But he that regardeth reproof is prudent.",
  },
  {
    reference: 'ISAIAH 44:3',
    referenceURL: 'https://www.bible.com/bible/1/ISA.44.3.KJV',
    verseText:
      'For I will pour water upon him that is thirsty, and floods upon the dry ground: I will pour my spirit upon thy seed, and my blessing upon thine offspring',
  },
  {
    reference: 'EXODUS 20:17',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.17.KJV',
    verseText:
      "Thou shalt not covet thy neighbour's house, thou shalt not covet thy neighbour's wife, nor his manservant, nor his maidservant, nor his ox, nor his ass, nor any thing that is thy neighbour's.",
  },
  {
    reference: '2 CORINTHIANS 1:3',
    referenceURL: 'https://www.bible.com/bible/1/2CO.1.3.KJV',
    verseText:
      'Blessed be God, even the Father of our Lord Jesus Christ, the Father of mercies, and the God of all comfort',
  },
  {
    reference: 'ROMANS 1:16',
    referenceURL: 'https://www.bible.com/bible/1/ROM.1.16.KJV',
    verseText:
      'For I am not ashamed of the gospel of Christ: for it is the power of God unto salvation to every one that believeth; to the Jew first, and also to the Greek.',
  },
  {
    reference: 'MALACHI 4:5',
    referenceURL: 'https://www.bible.com/bible/1/MAL.4.5.KJV',
    verseText:
      'Behold, I will send you Elijah the prophet before the coming of the great and dreadful day of the LORD',
  },
  {
    reference: '1 CORINTHIANS 2:9',
    referenceURL: 'https://www.bible.com/bible/1/1CO.2.9.KJV',
    verseText:
      'But as it is written, Eye hath not seen, nor ear heard, Neither have entered into the heart of man, The things which God hath prepared for them that love him.',
  },
  {
    reference: 'PROVERBS 18:10',
    referenceURL: 'https://www.bible.com/bible/1/PRO.18.10.KJV',
    verseText:
      'The name of the LORD is a strong tower: The righteous runneth into it, and is safe.',
  },
  {
    reference: 'JAMES 5:13',
    referenceURL: 'https://www.bible.com/bible/1/JAS.5.13.KJV',
    verseText:
      'Is any among you afflicted? let him pray. Is any merry? let him sing psalms.',
  },
  {
    reference: 'LUKE 4:40',
    referenceURL: 'https://www.bible.com/bible/1/LUK.4.40.KJV',
    verseText:
      'Now when the sun was setting, all they that had any sick with divers diseases brought them unto him; and he laid his hands on every one of them, and healed them.',
  },
  {
    reference: 'PSALM 18:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.18.2.KJV',
    verseText:
      'The LORD is my rock, and my fortress, and my deliverer; My God, my strength, in whom I will trust; My buckler, and the horn of my salvation, and my high tower.',
  },
  {
    reference: 'JOHN 16:24',
    referenceURL: 'https://www.bible.com/bible/1/JHN.16.24.KJV',
    verseText:
      'Hitherto have ye asked nothing in my name: ask, and ye shall receive, that your joy may be full.',
  },
  {
    reference: 'EPHESIANS 6:1',
    referenceURL: 'https://www.bible.com/bible/1/EPH.6.1.KJV',
    verseText: 'Children, obey your parents in the Lord: for this is right.',
  },
  {
    reference: 'PROVERBS 20:7',
    referenceURL: 'https://www.bible.com/bible/1/PRO.20.7.KJV',
    verseText:
      'The just man walketh in his integrity: His children are blessed after him.',
  },
  {
    reference: 'EXODUS 23:25',
    referenceURL: 'https://www.bible.com/bible/1/EXO.23.25.KJV',
    verseText:
      'And ye shall serve the LORD your God, and he shall bless thy bread, and thy water; and I will take sickness away from the midst of thee.',
  },
  {
    reference: 'MATTHEW 13:44',
    referenceURL: 'https://www.bible.com/bible/1/MAT.13.44.KJV',
    verseText:
      'Again, the kingdom of heaven is like unto treasure hid in a field; the which when a man hath found, he hideth, and for joy thereof goeth and selleth all that he hath, and buyeth that field.',
  },
  {
    reference: 'PROVERBS 18:22',
    referenceURL: 'https://www.bible.com/bible/1/PRO.18.22.KJV',
    verseText:
      'Whoso findeth a wife findeth a good thing, And obtaineth favour of the LORD.',
  },
  {
    reference: 'PROVERBS 22:6',
    referenceURL: 'https://www.bible.com/bible/1/PRO.22.6.KJV',
    verseText:
      'Train up a child in the way he should go: And when he is old, he will not depart from it.',
  },
  {
    reference: 'ISAIAH 54:13',
    referenceURL: 'https://www.bible.com/bible/1/ISA.54.13.KJV',
    verseText:
      'And all thy children shall be taught of the LORD; and great shall be the peace of thy children.',
  },
  {
    reference: 'PSALM 150:6',
    referenceURL: 'https://www.bible.com/bible/1/PSA.150.6.KJV',
    verseText:
      'Let every thing that hath breath Praise the LORD. Praise ye the LORD.',
  },
  {
    reference: 'PSALM 37:3',
    referenceURL: 'https://www.bible.com/bible/1/PSA.37.3.KJV',
    verseText:
      'Trust in the LORD, and do good; So shalt thou dwell in the land, and verily thou shalt be fed.',
  },
  {
    reference: 'JOHN 3:5',
    referenceURL: 'https://www.bible.com/bible/1/JHN.3.5.KJV',
    verseText:
      'Jesus answered, Verily, verily, I say unto thee, Except a man be born of water and of the Spirit, he cannot enter into the kingdom of God.',
  },
  {
    reference: 'ROMANS 5:5',
    referenceURL: 'https://www.bible.com/bible/1/ROM.5.5.KJV',
    verseText:
      'and hope maketh not ashamed; because the love of God is shed abroad in our hearts by the Holy Ghost which is given unto us.',
  },
  {
    reference: 'JOHN 14:1',
    referenceURL: 'https://www.bible.com/bible/1/JHN.14.1.KJV',
    verseText:
      'Let not your heart be troubled: ye believe in God, believe also in me.',
  },
  {
    reference: '1 JOHN 3:18',
    referenceURL: 'https://www.bible.com/bible/1/1JN.3.18.KJV',
    verseText:
      'My little children, let us not love in word, neither in tongue; but in deed and in truth.',
  },
  {
    reference: 'EXODUS 20:11',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.11.KJV',
    verseText:
      'for in six days the LORD made heaven and earth, the sea, and all that in them is, and rested the seventh day: wherefore the LORD blessed the sabbath day, and hallowed it.',
  },
  {
    reference: 'PSALM 103:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.103.2.KJV',
    verseText: 'Bless the LORD, O my soul, And forget not all his benefits',
  },
  {
    reference: 'EPHESIANS 5:28',
    referenceURL: 'https://www.bible.com/bible/1/EPH.5.28.KJV',
    verseText:
      'So ought men to love their wives as their own bodies. He that loveth his wife loveth himself.',
  },
  {
    reference: 'PSALM 92:13',
    referenceURL: 'https://www.bible.com/bible/1/PSA.92.13.KJV',
    verseText:
      'Those that be planted in the house of the LORD Shall flourish in the courts of our God.',
  },
  {
    reference: '1 PETER 3:1',
    referenceURL: 'https://www.bible.com/bible/1/1PE.3.1.KJV',
    verseText:
      'Likewise, ye wives, be in subjection to your own husbands; that, if any obey not the word, they also may without the word be won by the conversation of the wives',
  },
  {
    reference: 'PSALM 62:8',
    referenceURL: 'https://www.bible.com/bible/1/PSA.62.8.KJV',
    verseText:
      'Trust in him at all times; ye people, Pour out your heart before him: God is a refuge for us. Selah.',
  },
  {
    reference: 'COLOSSIANS 1:27',
    referenceURL: 'https://www.bible.com/bible/1/COL.1.27.KJV',
    verseText:
      'to whom God would make known what is the riches of the glory of this mystery among the Gentiles; which is Christ in you, the hope of glory',
  },
  {
    reference: 'ISAIAH 52:7',
    referenceURL: 'https://www.bible.com/bible/1/ISA.52.7.KJV',
    verseText:
      'How beautiful upon the mountains are the feet of him that bringeth good tidings, that publisheth peace; that bringeth good tidings of good, that publisheth salvation; that saith unto Zion, Thy God reigneth!',
  },
  {
    reference: 'PROVERBS 3:1',
    referenceURL: 'https://www.bible.com/bible/1/PRO.3.1.KJV',
    verseText:
      'My son, forget not my law; But let thine heart keep my commandments',
  },
  {
    reference: 'PROVERBS 3:13',
    referenceURL: 'https://www.bible.com/bible/1/PRO.3.13.KJV',
    verseText:
      'Happy is the man that findeth wisdom, And the man that getteth understanding.',
  },
  {
    reference: 'GENESIS 2:3',
    referenceURL: 'https://www.bible.com/bible/1/GEN.2.3.KJV',
    verseText:
      'And God blessed the seventh day, and sanctified it: because that in it he had rested from all his work which God created and made.',
  },
  {
    reference: '1 CORINTHIANS 16:13',
    referenceURL: 'https://www.bible.com/bible/1/1CO.16.13.KJV',
    verseText:
      'Watch ye, stand fast in the faith, quit you like men, be strong.',
  },
  {
    reference: 'PSALM 119:105',
    referenceURL: 'https://www.bible.com/bible/1/PSA.119.105.KJV',
    verseText: 'Thy word is a lamp unto my feet, And a light unto my path.',
  },
  {
    reference: 'JEREMIAH 33:3',
    referenceURL: 'https://www.bible.com/bible/1/JER.33.3.KJV',
    verseText:
      'Call unto me, and I will answer thee, and shew thee great and mighty things, which thou knowest not.',
  },
  {
    reference: 'PSALM 16:7',
    referenceURL: 'https://www.bible.com/bible/1/PSA.16.7.KJV',
    verseText:
      'I will bless the LORD, who hath given me counsel: My reins also instruct me in the night seasons.',
  },
  {
    reference: '2 THESSALONIANS 3:16',
    referenceURL: 'https://www.bible.com/bible/1/2TH.3.16.KJV',
    verseText:
      'Now the Lord of peace himself give you peace always by all means. The Lord be with you all.',
  },
  {
    reference: 'PSALM 55:16',
    referenceURL: 'https://www.bible.com/bible/1/PSA.55.16.KJV',
    verseText: 'As for me, I will call upon God; And the LORD shall save me.',
  },
  {
    reference: 'COLOSSIANS 3:20',
    referenceURL: 'https://www.bible.com/bible/1/COL.3.20.KJV',
    verseText:
      'Children, obey your parents in all things: for this is well pleasing unto the Lord.',
  },
  {
    reference: 'COLOSSIANS 1:9',
    referenceURL: 'https://www.bible.com/bible/1/COL.1.9.KJV',
    verseText:
      'For this cause we also, since the day we heard it, do not cease to pray for you, and to desire that ye might be filled with the knowledge of his will in all wisdom and spiritual understanding',
  },
  {
    reference: 'PROVERBS 15:30',
    referenceURL: 'https://www.bible.com/bible/1/PRO.15.30.KJV',
    verseText:
      'The light of the eyes rejoiceth the heart: And a good report maketh the bones fat.',
  },
  {
    reference: 'PSALM 9:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.9.1.KJV',
    verseText:
      'I will praise thee, O LORD, with my whole heart; I will shew forth all thy marvellous works.',
  },
  {
    reference: 'ROMANS 12:18',
    referenceURL: 'https://www.bible.com/bible/1/ROM.12.18.KJV',
    verseText:
      'If it be possible, as much as lieth in you, live peaceably with all men.',
  },
  {
    reference: '1 PETER 3:18',
    referenceURL: 'https://www.bible.com/bible/1/1PE.3.18.KJV',
    verseText:
      'For Christ also hath once suffered for sins, the just for the unjust, that he might bring us to God, being put to death in the flesh, but quickened by the Spirit',
  },
  {
    reference: 'JOEL 2:28',
    referenceURL: 'https://www.bible.com/bible/1/JOL.2.28.KJV',
    verseText:
      'And it shall come to pass afterward, that I will pour out my spirit upon all flesh; and your sons and your daughters shall prophesy, your old men shall dream dreams, your young men shall see visions',
  },
  {
    reference: 'PSALM 100:4',
    referenceURL: 'https://www.bible.com/bible/1/PSA.100.4.KJV',
    verseText:
      'Enter into his gates with thanksgiving, And into his courts with praise: Be thankful unto him, and bless his name.',
  },
  {
    reference: '1 CORINTHIANS 1:4',
    referenceURL: 'https://www.bible.com/bible/1/1CO.1.4.KJV',
    verseText:
      'I thank my God always on your behalf, for the grace of God which is given you by Jesus Christ',
  },
  {
    reference: 'PSALM 46:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.46.1.KJV',
    verseText:
      'God is our refuge and strength, A very present help in trouble.',
  },
  {
    reference: 'MATTHEW 18:19',
    referenceURL: 'https://www.bible.com/bible/1/MAT.18.19.KJV',
    verseText:
      'Again I say unto you, That if two of you shall agree on earth as touching any thing that they shall ask, it shall be done for them of my Father which is in heaven.',
  },
  {
    reference: 'ACTS 4:29',
    referenceURL: 'https://www.bible.com/bible/1/ACT.4.29.KJV',
    verseText:
      'And now, Lord, behold their threatenings: and grant unto thy servants, that with all boldness they may speak thy word',
  },
  {
    reference: 'EXODUS 20:4',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.4.KJV',
    verseText:
      'Thou shalt not make unto thee any graven image, or any likeness of any thing that is in heaven above, or that is in the earth beneath, or that is in the water under the earth',
  },
  {
    reference: '2 THESSALONIANS 3:10',
    referenceURL: 'https://www.bible.com/bible/1/2TH.3.10.KJV',
    verseText:
      'For even when we were with you, this we commanded you, that if any would not work, neither should he eat.',
  },
  {
    reference: 'COLOSSIANS 3:21',
    referenceURL: 'https://www.bible.com/bible/1/COL.3.21.KJV',
    verseText:
      'Fathers, provoke not your children to anger, lest they be discouraged.',
  },
  {
    reference: '1 CORINTHIANS 13:1',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.1.KJV',
    verseText:
      'Though I speak with the tongues of men and of angels, and have not charity, I am become as sounding brass, or a tinkling cymbal.',
  },
  {
    reference: 'PSALM 21:4',
    referenceURL: 'https://www.bible.com/bible/1/PSA.21.4.KJV',
    verseText:
      'He asked life of thee, and thou gavest it him, Even length of days for ever and ever.',
  },
  {
    reference: 'PSALM 4:8',
    referenceURL: 'https://www.bible.com/bible/1/PSA.4.8.KJV',
    verseText:
      'I will both lay me down in peace, and sleep: For thou, LORD, only makest me dwell in safety.',
  },
  {
    reference: '1 JOHN 5:14',
    referenceURL: 'https://www.bible.com/bible/1/1JN.5.14.KJV',
    verseText:
      'And this is the confidence that we have in him, that, if we ask any thing according to his will, he heareth us',
  },
  {
    reference: 'JOHN 16:27',
    referenceURL: 'https://www.bible.com/bible/1/JHN.16.27.KJV',
    verseText:
      'for the Father himself loveth you, because ye have loved me, and have believed that I came out from God.',
  },
  {
    reference: 'JOHN 16:13',
    referenceURL: 'https://www.bible.com/bible/1/JHN.16.13.KJV',
    verseText:
      'Howbeit when he, the Spirit of truth, is come, he will guide you into all truth: for he shall not speak of himself; but whatsoever he shall hear, that shall he speak: and he will shew you things to come.',
  },
  {
    reference: 'PSALM 62:5',
    referenceURL: 'https://www.bible.com/bible/1/PSA.62.5.KJV',
    verseText:
      'My soul, wait thou only upon God; For my expectation is from him.',
  },
  {
    reference: 'JOHN 14:16',
    referenceURL: 'https://www.bible.com/bible/1/JHN.14.16.KJV',
    verseText:
      'And I will pray the Father, and he shall give you another Comforter, that he may abide with you for ever',
  },
  {
    reference: '1 CORINTHIANS 15:58',
    referenceURL: 'https://www.bible.com/bible/1/1CO.15.58.KJV',
    verseText:
      'Therefore, my beloved brethren, be ye stedfast, unmoveable, always abounding in the work of the Lord, forasmuch as ye know that your labour is not in vain in the Lord.',
  },
  {
    reference: '1 CHRONICLES 16:34',
    referenceURL: 'https://www.bible.com/bible/1/1CH.16.34.KJV',
    verseText:
      'O give thanks unto the LORD; for he is good; For his mercy endureth for ever.',
  },
  {
    reference: 'REVELATION 3:20',
    referenceURL: 'https://www.bible.com/bible/1/REV.3.20.KJV',
    verseText:
      'Behold, I stand at the door, and knock: if any man hear my voice, and open the door, I will come in to him, and will sup with him, and he with me.',
  },
  {
    reference: '1 CORINTHIANS 13:6',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.6.KJV',
    verseText: 'rejoiceth not in iniquity, but rejoiceth in the truth',
  },
  {
    reference: 'ROMANS 13:1',
    referenceURL: 'https://www.bible.com/bible/1/ROM.13.1.KJV',
    verseText:
      'Let every soul be subject unto the higher powers. For there is no power but of God: the powers that be are ordained of God.',
  },
  {
    reference: 'EPHESIANS 3:14',
    referenceURL: 'https://www.bible.com/bible/1/EPH.3.14.KJV',
    verseText:
      'For this cause I bow my knees unto the Father of our Lord Jesus Christ',
  },
  {
    reference: 'PSALM 121:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.121.2.KJV',
    verseText: 'My help cometh from the LORD, Which made heaven and earth.',
  },
  {
    reference: 'PSALM 150:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.150.1.KJV',
    verseText:
      'Praise ye the LORD. Praise God in his sanctuary: Praise him in the firmament of his power.',
  },
  {
    reference: '1 CORINTHIANS 13:4',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.4.KJV',
    verseText:
      'Charity suffereth long, and is kind; charity envieth not; charity vaunteth not itself, is not puffed up',
  },
  {
    reference: 'JEREMIAH 17:14',
    referenceURL: 'https://www.bible.com/bible/1/JER.17.14.KJV',
    verseText:
      'Heal me, O LORD, and I shall be healed; save me, and I shall be saved: for thou art my praise.',
  },
  {
    reference: 'COLOSSIANS 3:18',
    referenceURL: 'https://www.bible.com/bible/1/COL.3.18.KJV',
    verseText:
      'Wives, submit yourselves unto your own husbands, as it is fit in the Lord.',
  },
  {
    reference: 'PROVERBS 16:3',
    referenceURL: 'https://www.bible.com/bible/1/PRO.16.3.KJV',
    verseText:
      'Commit thy works unto the LORD, And thy thoughts shall be established.',
  },
  {
    reference: 'MATTHEW 18:18',
    referenceURL: 'https://www.bible.com/bible/1/MAT.18.18.KJV',
    verseText:
      'Verily I say unto you, Whatsoever ye shall bind on earth shall be bound in heaven: and whatsoever ye shall loose on earth shall be loosed in heaven.',
  },
  {
    reference: 'MARK 16:15',
    referenceURL: 'https://www.bible.com/bible/1/MRK.16.15.KJV',
    verseText:
      'And he said unto them, Go ye into all the world, and preach the gospel to every creature.',
  },
  {
    reference: '1 CORINTHIANS 13:3',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.3.KJV',
    verseText:
      'And though I bestow all my goods to feed the poor, and though I give my body to be burned, and have not charity, it profiteth me nothing.',
  },
  {
    reference: 'ROMANS 10:1',
    referenceURL: 'https://www.bible.com/bible/1/ROM.10.1.KJV',
    verseText:
      "Brethren, my heart's desire and prayer to God for Israel is, that they might be saved.",
  },
  {
    reference: 'ROMANS 14:17',
    referenceURL: 'https://www.bible.com/bible/1/ROM.14.17.KJV',
    verseText:
      'for the kingdom of God is not meat and drink; but righteousness, and peace, and joy in the Holy Ghost.',
  },
  {
    reference: '2 THESSALONIANS 1:11',
    referenceURL: 'https://www.bible.com/bible/1/2TH.1.11.KJV',
    verseText:
      'Wherefore also we pray always for you, that our God would count you worthy of this calling, and fulfil all the good pleasure of his goodness, and the work of faith with power',
  },
  {
    reference: 'PROVERBS 4:5',
    referenceURL: 'https://www.bible.com/bible/1/PRO.4.5.KJV',
    verseText:
      'Get wisdom, get understanding: Forget it not; neither decline from the words of my mouth.',
  },
  {
    reference: 'JEREMIAH 17:7',
    referenceURL: 'https://www.bible.com/bible/1/JER.17.7.KJV',
    verseText:
      'Blessed is the man that trusteth in the LORD, and whose hope the LORD is.',
  },
  {
    reference: 'PROVERBS 1:7',
    referenceURL: 'https://www.bible.com/bible/1/PRO.1.7.KJV',
    verseText:
      'The fear of the LORD is the beginning of knowledge: But fools despise wisdom and instruction.',
  },
  {
    reference: '1 PETER 4:8',
    referenceURL: 'https://www.bible.com/bible/1/1PE.4.8.KJV',
    verseText:
      'And above all things have fervent charity among yourselves: for charity shall cover the multitude of sins.',
  },
  {
    reference: 'HEBREWS 12:11',
    referenceURL: 'https://www.bible.com/bible/1/HEB.12.11.KJV',
    verseText:
      'Now no chastening for the present seemeth to be joyous, but grievous: nevertheless afterward it yieldeth the peaceable fruit of righteousness unto them which are exercised thereby.',
  },
  {
    reference: 'MATTHEW 10:1',
    referenceURL: 'https://www.bible.com/bible/1/MAT.10.1.KJV',
    verseText:
      'And when he had called unto him his twelve disciples, he gave them power against unclean spirits, to cast them out, and to heal all manner of sickness and all manner of disease.',
  },
  {
    reference: 'EPHESIANS 5:31',
    referenceURL: 'https://www.bible.com/bible/1/EPH.5.31.KJV',
    verseText:
      'For this cause shall a man leave his father and mother, and shall be joined unto his wife, and they two shall be one flesh.',
  },
  {
    reference: 'ISAIAH 61:1',
    referenceURL: 'https://www.bible.com/bible/1/ISA.61.1.KJV',
    verseText:
      'The Spirit of the Lord GOD is upon me; because the LORD hath anointed me to preach good tidings unto the meek; he hath sent me to bind up the brokenhearted, to proclaim liberty to the captives, and the opening of the prison to them that are bound',
  },
  {
    reference: 'PSALM 127:3',
    referenceURL: 'https://www.bible.com/bible/1/PSA.127.3.KJV',
    verseText:
      'Lo, children are an heritage of the LORD: And the fruit of the womb is his reward.',
  },
  {
    reference: 'ROMANS 8:1',
    referenceURL: 'https://www.bible.com/bible/1/ROM.8.1.KJV',
    verseText:
      'There is therefore now no condemnation to them which are in Christ Jesus, who walk not after the flesh, but after the Spirit.',
  },
  {
    reference: 'PSALM 32:7',
    referenceURL: 'https://www.bible.com/bible/1/PSA.32.7.KJV',
    verseText:
      'Thou art my hiding place; thou shalt preserve me from trouble; Thou shalt compass me about with songs of deliverance. Selah.',
  },
  {
    reference: 'DEUTERONOMY 6:6',
    referenceURL: 'https://www.bible.com/bible/1/DEU.6.6.KJV',
    verseText:
      'And these words, which I command thee this day, shall be in thine heart',
  },
  {
    reference: 'PROVERBS 10:5',
    referenceURL: 'https://www.bible.com/bible/1/PRO.10.5.KJV',
    verseText:
      'He that gathereth in summer is a wise son: But he that sleepeth in harvest is a son that causeth shame.',
  },
  {
    reference: 'PSALM 5:12',
    referenceURL: 'https://www.bible.com/bible/1/PSA.5.12.KJV',
    verseText:
      'For thou, LORD, wilt bless the righteous; With favour wilt thou compass him as with a shield.',
  },
  {
    reference: 'LUKE 6:31',
    referenceURL: 'https://www.bible.com/bible/1/LUK.6.31.KJV',
    verseText:
      'And as ye would that men should do to you, do ye also to them likewise.',
  },
  {
    reference: 'PSALM 78:4',
    referenceURL: 'https://www.bible.com/bible/1/PSA.78.4.KJV',
    verseText:
      'We will not hide them from their children, shewing to the generation to come, The praises of the LORD, and his strength, and his wonderful works that he hath done.',
  },
  {
    reference: 'PSALM 136:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.136.1.KJV',
    verseText:
      'O give thanks unto the LORD; for he is good: For his mercy endureth for ever.',
  },
  {
    reference: 'PSALM 41:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.41.1.KJV',
    verseText:
      'Blessed is he that considereth the poor: The LORD will deliver him in time of trouble.',
  },
  {
    reference: 'PHILIPPIANS 2:3',
    referenceURL: 'https://www.bible.com/bible/1/PHP.2.3.KJV',
    verseText:
      'Let nothing be done through strife or vainglory; but in lowliness of mind let each esteem other better than themselves.',
  },
  {
    reference: 'RUTH 1:16',
    referenceURL: 'https://www.bible.com/bible/1/RUT.1.16.KJV',
    verseText:
      'And Ruth said, Intreat me not to leave thee, or to return from following after thee: for whither thou goest, I will go; and where thou lodgest, I will lodge: thy people shall be my people, and thy God my God',
  },
  {
    reference: 'PROVERBS 16:24',
    referenceURL: 'https://www.bible.com/bible/1/PRO.16.24.KJV',
    verseText:
      'Pleasant words are as an honeycomb, Sweet to the soul, and health to the bones.',
  },
  {
    reference: 'ISAIAH 54:17',
    referenceURL: 'https://www.bible.com/bible/1/ISA.54.17.KJV',
    verseText:
      'No weapon that is formed against thee shall prosper; and every tongue that shall rise against thee in judgment thou shalt condemn. This is the heritage of the servants of the LORD, and their righteousness is of me, saith the LORD.',
  },
  {
    reference: 'PSALM 125:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.125.1.KJV',
    verseText:
      'They that trust in the LORD Shall be as mount Zion, Which cannot be removed, But abideth for ever.',
  },
  {
    reference: '1 PETER 4:9',
    referenceURL: 'https://www.bible.com/bible/1/1PE.4.9.KJV',
    verseText: 'Use hospitality one to another without grudging.',
  },
  {
    reference: '1 THESSALONIANS 3:9',
    referenceURL: 'https://www.bible.com/bible/1/1TH.3.9.KJV',
    verseText:
      'For what thanks can we render to God again for you, for all the joy wherewith we joy for your sakes before our God',
  },
  {
    reference: '1 CORINTHIANS 13:10',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.10.KJV',
    verseText:
      'But when that which is perfect is come, then that which is in part shall be done away.',
  },
  {
    reference: 'MATTHEW 6:9',
    referenceURL: 'https://www.bible.com/bible/1/MAT.6.9.KJV',
    verseText:
      'After this manner therefore pray ye: Our Father which art in heaven, Hallowed be thy name.',
  },
  {
    reference: 'PSALM 56:3',
    referenceURL: 'https://www.bible.com/bible/1/PSA.56.3.KJV',
    verseText: 'What time I am afraid, I will trust in thee.',
  },
  {
    reference: 'PROVERBS 20:29',
    referenceURL: 'https://www.bible.com/bible/1/PRO.20.29.KJV',
    verseText:
      'The glory of young men is their strength: And the beauty of old men is the grey head.',
  },
  {
    reference: 'PSALM 42:11',
    referenceURL: 'https://www.bible.com/bible/1/PSA.42.11.KJV',
    verseText:
      'Why art thou cast down, O my soul? And why art thou disquieted within me? Hope thou in God; For I shall yet praise him, who is the health of my countenance, and my God.',
  },
  {
    reference: '2 CORINTHIANS 4:17',
    referenceURL: 'https://www.bible.com/bible/1/2CO.4.17.KJV',
    verseText:
      'For our light affliction, which is but for a moment, worketh for us a far more exceeding and eternal weight of glory',
  },
  {
    reference: 'MATTHEW 7:7',
    referenceURL: 'https://www.bible.com/bible/1/MAT.7.7.KJV',
    verseText:
      'Ask, and it shall be given you; seek, and ye shall find; knock, and it shall be opened unto you',
  },
  {
    reference: 'PSALM 112:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.112.1.KJV',
    verseText:
      'Praise ye the LORD. Blessed is the man that feareth the LORD, That delighteth greatly in his commandments.',
  },
  {
    reference: 'PROVERBS 16:20',
    referenceURL: 'https://www.bible.com/bible/1/PRO.16.20.KJV',
    verseText:
      'He that handleth a matter wisely shall find good: And whoso trusteth in the LORD, happy is he.',
  },
  {
    reference: 'PSALM 84:11',
    referenceURL: 'https://www.bible.com/bible/1/PSA.84.11.KJV',
    verseText:
      'For the LORD God is a sun and shield: The LORD will give grace and glory: No good thing will he withhold from them that walk uprightly.',
  },
  {
    reference: 'PSALM 27:5',
    referenceURL: 'https://www.bible.com/bible/1/PSA.27.5.KJV',
    verseText:
      'For in the time of trouble he shall hide me in his pavilion: In the secret of his tabernacle shall he hide me; he shall set me up upon a rock.',
  },
  {
    reference: 'PROVERBS 20:13',
    referenceURL: 'https://www.bible.com/bible/1/PRO.20.13.KJV',
    verseText:
      'Love not sleep, lest thou come to poverty; Open thine eyes, and thou shalt be satisfied with bread.',
  },
  {
    reference: '1 CORINTHIANS 13:13',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.13.KJV',
    verseText:
      'And now abideth faith, hope, charity, these three; but the greatest of these is charity.',
  },
  {
    reference: 'PSALM 34:17',
    referenceURL: 'https://www.bible.com/bible/1/PSA.34.17.KJV',
    verseText:
      'The righteous cry, and the LORD heareth, And delivereth them out of all their troubles.',
  },
  {
    reference: 'EPHESIANS 1:15',
    referenceURL: 'https://www.bible.com/bible/1/EPH.1.15.KJV',
    verseText:
      'Wherefore I also, after I heard of your faith in the Lord Jesus, and love unto all the saints',
  },
  {
    reference: '1 CORINTHIANS 13:11',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.11.KJV',
    verseText:
      'When I was a child, I spake as a child, I understood as a child, I thought as a child: but when I became a man, I put away childish things.',
  },
  {
    reference: 'MATTHEW 5:11',
    referenceURL: 'https://www.bible.com/bible/1/MAT.5.11.KJV',
    verseText:
      'Blessed are ye, when men shall revile you, and persecute you, and shall say all manner of evil against you falsely, for my sake.',
  },
  {
    reference: 'MALACHI 2:16',
    referenceURL: 'https://www.bible.com/bible/1/MAL.2.16.KJV',
    verseText:
      'For the LORD, the God of Israel, saith that he hateth putting away: for one covereth violence with his garment, saith the LORD of hosts: therefore take heed to your spirit, that ye deal not treacherously.',
  },
  {
    reference: 'PROVERBS 3:21',
    referenceURL: 'https://www.bible.com/bible/1/PRO.3.21.KJV',
    verseText:
      'My son, let not them depart from thine eyes: Keep sound wisdom and discretion',
  },
  {
    reference: 'PROVERBS 23:24',
    referenceURL: 'https://www.bible.com/bible/1/PRO.23.24.KJV',
    verseText:
      'The father of the righteous shall greatly rejoice: And he that begetteth a wise child shall have joy of him.',
  },
  {
    reference: 'JOB 12:12',
    referenceURL: 'https://www.bible.com/bible/1/JOB.12.12.KJV',
    verseText:
      'With the ancient is wisdom; And in length of days understanding.',
  },
  {
    reference: 'PROVERBS 4:20',
    referenceURL: 'https://www.bible.com/bible/1/PRO.4.20.KJV',
    verseText: 'My son, attend to my words; Incline thine ear unto my sayings.',
  },
  {
    reference: 'JOSHUA 22:5',
    referenceURL: 'https://www.bible.com/bible/1/JOS.22.5.KJV',
    verseText:
      'But take diligent heed to do the commandment and the law, which Moses the servant of the LORD charged you, to love the LORD your God, and to walk in all his ways, and to keep his commandments, and to cleave unto him, and to serve him with all your heart and with all your soul.',
  },
  {
    reference: 'PROVERBS 22:29',
    referenceURL: 'https://www.bible.com/bible/1/PRO.22.29.KJV',
    verseText:
      'Seest thou a man diligent in his business? he shall stand before kings; He shall not stand before mean men.',
  },
  {
    reference: 'PSALM 29:11',
    referenceURL: 'https://www.bible.com/bible/1/PSA.29.11.KJV',
    verseText:
      'The LORD will give strength unto his people; The LORD will bless his people with peace.',
  },
  {
    reference: 'DEUTERONOMY 30:9',
    referenceURL: 'https://www.bible.com/bible/1/DEU.30.9.KJV',
    verseText:
      'And the LORD thy God will make thee plenteous in every work of thine hand, in the fruit of thy body, and in the fruit of thy cattle, and in the fruit of thy land, for good: for the LORD will again rejoice over thee for good, as he rejoiced over thy fathers',
  },
  {
    reference: 'ACTS 20:24',
    referenceURL: 'https://www.bible.com/bible/1/ACT.20.24.KJV',
    verseText:
      'But none of these things move me, neither count I my life dear unto myself, so that I might finish my course with joy, and the ministry, which I have received of the Lord Jesus, to testify the gospel of the grace of God.',
  },
  {
    reference: 'EXODUS 20:14',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.14.KJV',
    verseText: 'Thou shalt not commit adultery.',
  },
  {
    reference: '1 CORINTHIANS 13:5',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.5.KJV',
    verseText:
      'doth not behave itself unseemly, seeketh not her own, is not easily provoked, thinketh no evil',
  },
  {
    reference: 'PROVERBS 29:15',
    referenceURL: 'https://www.bible.com/bible/1/PRO.29.15.KJV',
    verseText:
      'The rod and reproof give wisdom: But a child left to himself bringeth his mother to shame.',
  },
  {
    reference: '1 PETER 1:3',
    referenceURL: 'https://www.bible.com/bible/1/1PE.1.3.KJV',
    verseText:
      'Blessed be the God and Father of our Lord Jesus Christ, which according to his abundant mercy hath begotten us again unto a lively hope by the resurrection of Jesus Christ from the dead',
  },
  {
    reference: 'MATTHEW 7:24',
    referenceURL: 'https://www.bible.com/bible/1/MAT.7.24.KJV',
    verseText:
      'Therefore whosoever heareth these sayings of mine, and doeth them, I will liken him unto a wise man, which built his house upon a rock',
  },
  {
    reference: 'PSALM 27:1',
    referenceURL: 'https://www.bible.com/bible/1/PSA.27.1.KJV',
    verseText:
      'The LORD is my light and my salvation; whom shall I fear? The LORD is the strength of my life; of whom shall I be afraid?',
  },
  {
    reference: '1 CORINTHIANS 13:8',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.8.KJV',
    verseText:
      'Charity never faileth: but whether there be prophecies, they shall fail; whether there be tongues, they shall cease; whether there be knowledge, it shall vanish away.',
  },
  {
    reference: 'PROVERBS 10:27',
    referenceURL: 'https://www.bible.com/bible/1/PRO.10.27.KJV',
    verseText:
      'The fear of the LORD prolongeth days: But the years of the wicked shall be shortened.',
  },
  {
    reference: 'MATTHEW 6:6',
    referenceURL: 'https://www.bible.com/bible/1/MAT.6.6.KJV',
    verseText:
      'But thou, when thou prayest, enter into thy closet, and when thou hast shut thy door, pray to thy Father which is in secret; and thy Father which seeth in secret shall reward thee openly.',
  },
  {
    reference: 'MATTHEW 24:14',
    referenceURL: 'https://www.bible.com/bible/1/MAT.24.14.KJV',
    verseText:
      'And this gospel of the kingdom shall be preached in all the world for a witness unto all nations; and then shall the end come.',
  },
  {
    reference: 'PROVERBS 29:25',
    referenceURL: 'https://www.bible.com/bible/1/PRO.29.25.KJV',
    verseText:
      'The fear of man bringeth a snare: But whoso putteth his trust in the LORD shall be safe.',
  },
  {
    reference: 'PSALM 128:3',
    referenceURL: 'https://www.bible.com/bible/1/PSA.128.3.KJV',
    verseText:
      'Thy wife shall be as a fruitful vine by the sides of thine house: Thy children like olive plants round about thy table.',
  },
  {
    reference: 'PSALM 33:18',
    referenceURL: 'https://www.bible.com/bible/1/PSA.33.18.KJV',
    verseText:
      'Behold, the eye of the LORD is upon them that fear him, Upon them that hope in his mercy',
  },
  {
    reference: 'EPHESIANS 5:1',
    referenceURL: 'https://www.bible.com/bible/1/EPH.5.1.KJV',
    verseText: 'Be ye therefore followers of God, as dear children',
  },
  {
    reference: '1 CHRONICLES 29:11',
    referenceURL: 'https://www.bible.com/bible/1/1CH.29.11.KJV',
    verseText:
      'Thine, O LORD, is the greatness, and the power, and the glory, and the victory, and the majesty: for all that is in the heaven and in the earth is thine; thine is the kingdom, O LORD, and thou art exalted as head above all.',
  },
  {
    reference: 'PSALM 61:3',
    referenceURL: 'https://www.bible.com/bible/1/PSA.61.3.KJV',
    verseText:
      'For thou hast been a shelter for me, and a strong tower from the enemy.',
  },
  {
    reference: 'ROMANS 8:11',
    referenceURL: 'https://www.bible.com/bible/1/ROM.8.11.KJV',
    verseText:
      'But if the Spirit of him that raised up Jesus from the dead dwell in you, he that raised up Christ from the dead shall also quicken your mortal bodies by his Spirit that dwelleth in you.',
  },
  {
    reference: '1 CORINTHIANS 13:7',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.7.KJV',
    verseText:
      'beareth all things, believeth all things, hopeth all things, endureth all things.',
  },
  {
    reference: 'JOHN 14:26',
    referenceURL: 'https://www.bible.com/bible/1/JHN.14.26.KJV',
    verseText:
      'But the Comforter, which is the Holy Ghost, whom the Father will send in my name, he shall teach you all things, and bring all things to your remembrance, whatsoever I have said unto you.',
  },
  {
    reference: '2 CORINTHIANS 3:18',
    referenceURL: 'https://www.bible.com/bible/1/2CO.3.18.KJV',
    verseText:
      'But we all, with open face beholding as in a glass the glory of the Lord, are changed into the same image from glory to glory, even as by the Spirit of the Lord.',
  },
  {
    reference: 'MARK 11:24',
    referenceURL: 'https://www.bible.com/bible/1/MRK.11.24.KJV',
    verseText:
      'Therefore I say unto you, What things soever ye desire, when ye pray, believe that ye receive them, and ye shall have them.',
  },
  {
    reference: 'PSALM 33:22',
    referenceURL: 'https://www.bible.com/bible/1/PSA.33.22.KJV',
    verseText:
      'Let thy mercy, O LORD, be upon us, According as we hope in thee.',
  },
  {
    reference: 'PSALM 103:17',
    referenceURL: 'https://www.bible.com/bible/1/PSA.103.17.KJV',
    verseText:
      "But the mercy of the LORD is from everlasting to everlasting upon them that fear him, And his righteousness unto children's children",
  },
  {
    reference: 'DEUTERONOMY 11:18',
    referenceURL: 'https://www.bible.com/bible/1/DEU.11.18.KJV',
    verseText:
      'Therefore shall ye lay up these my words in your heart and in your soul, and bind them for a sign upon your hand, that they may be as frontlets between your eyes.',
  },
  {
    reference: 'EPHESIANS 6:4',
    referenceURL: 'https://www.bible.com/bible/1/EPH.6.4.KJV',
    verseText:
      'And, ye fathers, provoke not your children to wrath: but bring them up in the nurture and admonition of the Lord.',
  },
  {
    reference: 'DEUTERONOMY 4:29',
    referenceURL: 'https://www.bible.com/bible/1/DEU.4.29.KJV',
    verseText:
      'But if from thence thou shalt seek the LORD thy God, thou shalt find him, if thou seek him with all thy heart and with all thy soul.',
  },
  {
    reference: 'PSALM 30:2',
    referenceURL: 'https://www.bible.com/bible/1/PSA.30.2.KJV',
    verseText: 'O LORD my God, I cried unto thee, and thou hast healed me.',
  },
  {
    reference: '1 JOHN 4:19',
    referenceURL: 'https://www.bible.com/bible/1/1JN.4.19.KJV',
    verseText: 'We love him, because he first loved us.',
  },
  {
    reference: '2 THESSALONIANS 3:1',
    referenceURL: 'https://www.bible.com/bible/1/2TH.3.1.KJV',
    verseText:
      'Finally, brethren, pray for us, that the word of the Lord may have free course, and be glorified, even as it is with you',
  },
  {
    reference: 'ROMANS 8:6',
    referenceURL: 'https://www.bible.com/bible/1/ROM.8.6.KJV',
    verseText:
      'For to be carnally minded is death; but to be spiritually minded is life and peace.',
  },
  {
    reference: 'JAMES 2:17',
    referenceURL: 'https://www.bible.com/bible/1/JAS.2.17.KJV',
    verseText: 'Even so faith, if it hath not works, is dead, being alone.',
  },
  {
    reference: 'PROVERBS 17:9',
    referenceURL: 'https://www.bible.com/bible/1/PRO.17.9.KJV',
    verseText:
      'He that covereth a transgression seeketh love; But he that repeateth a matter separateth very friends.',
  },
  {
    reference: 'PROVERBS 19:14',
    referenceURL: 'https://www.bible.com/bible/1/PRO.19.14.KJV',
    verseText:
      'House and riches are the inheritance of fathers: And a prudent wife is from the LORD.',
  },
  {
    reference: 'PROVERBS 14:7',
    referenceURL: 'https://www.bible.com/bible/1/PRO.14.7.KJV',
    verseText:
      'Go from the presence of a foolish man, When thou perceivest not in him the lips of knowledge.',
  },
  {
    reference: 'MATTHEW 19:4',
    referenceURL: 'https://www.bible.com/bible/1/MAT.19.4.KJV',
    verseText:
      'And he answered and said unto them, Have ye not read, that he which made them at the beginning made them male and female',
  },
  {
    reference: 'DEUTERONOMY 6:5',
    referenceURL: 'https://www.bible.com/bible/1/DEU.6.5.KJV',
    verseText:
      'and thou shalt love the LORD thy God with all thine heart, and with all thy soul, and with all thy might.',
  },
  {
    reference: '1 CORINTHIANS 13:9',
    referenceURL: 'https://www.bible.com/bible/1/1CO.13.9.KJV',
    verseText: 'For we know in part, and we prophesy in part.',
  },
  {
    reference: '1 THESSALONIANS 1:2',
    referenceURL: 'https://www.bible.com/bible/1/1TH.1.2.KJV',
    verseText:
      'We give thanks to God always for you all, making mention of you in our prayers',
  },
  {
    reference: 'MATTHEW 21:22',
    referenceURL: 'https://www.bible.com/bible/1/MAT.21.22.KJV',
    verseText:
      'And all things, whatsoever ye shall ask in prayer, believing, ye shall receive.',
  },
  {
    reference: 'MATTHEW 5:43',
    referenceURL: 'https://www.bible.com/bible/1/MAT.5.43.KJV',
    verseText:
      'Ye have heard that it hath been said, Thou shalt love thy neighbour, and hate thine enemy.',
  },
  {
    reference: 'ISAIAH 43:2',
    referenceURL: 'https://www.bible.com/bible/1/ISA.43.2.KJV',
    verseText:
      'When thou passest through the waters, I will be with thee; and through the rivers, they shall not overflow thee: when thou walkest through the fire, thou shalt not be burned; neither shall the flame kindle upon thee.',
  },
  {
    reference: '1 JOHN 2:10',
    referenceURL: 'https://www.bible.com/bible/1/1JN.2.10.KJV',
    verseText:
      'He that loveth his brother abideth in the light, and there is none occasion of stumbling in him.',
  },
  {
    reference: 'PSALM 119:159',
    referenceURL: 'https://www.bible.com/bible/1/PSA.119.159.KJV',
    verseText:
      'Consider how I love thy precepts: Quicken me, O LORD, according to thy lovingkindness.',
  },
  {
    reference: 'JAMES 5:14',
    referenceURL: 'https://www.bible.com/bible/1/JAS.5.14.KJV',
    verseText:
      'Is any sick among you? let him call for the elders of the church; and let them pray over him, anointing him with oil in the name of the Lord',
  },
  {
    reference: 'EXODUS 20:10',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.10.KJV',
    verseText:
      'but the seventh day is the sabbath of the LORD thy God: in it thou shalt not do any work, thou, nor thy son, nor thy daughter, thy manservant, nor thy maidservant, nor thy cattle, nor thy stranger that is within thy gates',
  },
  {
    reference: 'PSALM 37:4',
    referenceURL: 'https://www.bible.com/bible/1/PSA.37.4.KJV',
    verseText:
      'Delight thyself also in the LORD; And he shall give thee the desires of thine heart.',
  },
  {
    reference: '1 THESSALONIANS 4:16',
    referenceURL: 'https://www.bible.com/bible/1/1TH.4.16.KJV',
    verseText:
      'For the Lord himself shall descend from heaven with a shout, with the voice of the archangel, and with the trump of God: and the dead in Christ shall rise first',
  },
  {
    reference: 'JOHN 14:21',
    referenceURL: 'https://www.bible.com/bible/1/JHN.14.21.KJV',
    verseText:
      'He that hath my commandments, and keepeth them, he it is that loveth me: and he that loveth me shall be loved of my Father, and I will love him, and will manifest myself to him.',
  },
  {
    reference: 'EPHESIANS 6:18',
    referenceURL: 'https://www.bible.com/bible/1/EPH.6.18.KJV',
    verseText:
      'praying always with all prayer and supplication in the Spirit, and watching thereunto with all perseverance and supplication for all saints',
  },
  {
    reference: 'HEBREWS 2:18',
    referenceURL: 'https://www.bible.com/bible/1/HEB.2.18.KJV',
    verseText:
      'For in that he himself hath suffered being tempted, he is able to succour them that are tempted.',
  },
  {
    reference: 'PROVERBS 13:4',
    referenceURL: 'https://www.bible.com/bible/1/PRO.13.4.KJV',
    verseText:
      'The soul of the sluggard desireth, and hath nothing: But the soul of the diligent shall be made fat.',
  },
  {
    reference: 'PROVERBS 3:25',
    referenceURL: 'https://www.bible.com/bible/1/PRO.3.25.KJV',
    verseText:
      'Be not afraid of sudden fear, Neither of the desolation of the wicked, when it cometh.',
  },
  {
    reference: 'ISAIAH 9:6',
    referenceURL: 'https://www.bible.com/bible/1/ISA.9.6.KJV',
    verseText:
      'For unto us a child is born, unto us a son is given: and the government shall be upon his shoulder: and his name shall be called Wonderful, Counsellor, The mighty God, The everlasting Father, The Prince of Peace.',
  },
  {
    reference: 'PSALM 34:19',
    referenceURL: 'https://www.bible.com/bible/1/PSA.34.19.KJV',
    verseText:
      'Many are the afflictions of the righteous: But the LORD delivereth him out of them all.',
  },
  {
    reference: 'EXODUS 20:13',
    referenceURL: 'https://www.bible.com/bible/1/EXO.20.13.KJV',
    verseText: 'Thou shalt not kill.',
  },
  {
    reference: 'PHILIPPIANS 2:7',
    referenceURL: 'https://www.bible.com/bible/1/PHP.2.7.KJV',
    verseText:
      'but made himself of no reputation, and took upon him the form of a servant, and was made in the likeness of men',
  },
  {
    reference: '1 CORINTHIANS 2:12',
    referenceURL: 'https://www.bible.com/bible/1/1CO.2.12.KJV',
    verseText:
      'Now we have received, not the spirit of the world, but the spirit which is of God; that we might know the things that are freely given to us of God.',
  },
  {
    reference: 'REVELATION 5:12',
    referenceURL: 'https://www.bible.com/bible/1/REV.5.12.KJV',
    verseText:
      'saying with a loud voice, Worthy is the Lamb that was slain to receive power, and riches, and wisdom, and strength, and honour, and glory, and blessing.',
  },
  {
    reference: 'PSALM 37:40',
    referenceURL: 'https://www.bible.com/bible/1/PSA.37.40.KJV',
    verseText:
      'And the LORD shall help them, and deliver them: He shall deliver them from the wicked, and save them, because they trust in him.',
  },
  {
    reference: '1 CORINTHIANS 8:3',
    referenceURL: 'https://www.bible.com/bible/1/1CO.8.3.KJV',
    verseText: 'But if any man love God, the same is known of him.',
  },
  {
    reference: '1 THESSALONIANS 5:16',
    referenceURL: 'https://www.bible.com/bible/1/1TH.5.16.KJV',
    verseText: 'Rejoice evermore.',
  },
  {
    reference: 'LUKE 6:19',
    referenceURL: 'https://www.bible.com/bible/1/LUK.6.19.KJV',
    verseText:
      'And the whole multitude sought to touch him: for there went virtue out of him, and healed them all.',
  },
  {
    reference: 'PHILEMON 19',
    referenceURL: 'https://www.bible.com/bible/1/PHM.1.19.KJV',
    verseText:
      'I Paul have written it with mine own hand, I will repay it: albeit I do not say to thee how thou owest unto me even thine own self besides.',
  },
  {
    reference: 'JUDE 21',
    referenceURL: 'https://www.bible.com/bible/1/JUD.1.21.KJV',
    verseText:
      'keep yourselves in the love of God, looking for the mercy of our Lord Jesus Christ unto eternal life.',
  },
  {
    reference: 'JUDE 3',
    referenceURL: 'https://www.bible.com/bible/1/JUD.1.3.KJV',
    verseText:
      'Beloved, when I gave all diligence to write unto you of the common salvation, it was needful for me to write unto you, and exhort you that ye should earnestly contend for the faith which was once delivered unto the saints.',
  },
  {
    reference: 'PHILEMON 4',
    referenceURL: 'https://www.bible.com/bible/1/PHM.1.4.KJV',
    verseText: 'I thank my God, making mention of thee always in my prayers',
  },
  {
    reference: 'PHILEMON 15',
    referenceURL: 'https://www.bible.com/bible/1/PHM.1.15.KJV',
    verseText:
      'For perhaps he therefore departed for a season, that thou shouldest receive him for ever',
  },
  {
    reference: 'OBADIAH 3',
    referenceURL: 'https://www.bible.com/bible/1/OBA.1.3.KJV',
    verseText:
      'The pride of thine heart hath deceived thee, thou that dwellest in the clefts of the rock, whose habitation is high; that saith in his heart, Who shall bring me down to the ground?',
  },
  {
    reference: '3 JOHN 3',
    referenceURL: 'https://www.bible.com/bible/1/3JN.1.3.KJV',
    verseText:
      'For I rejoiced greatly, when the brethren came and testified of the truth that is in thee, even as thou walkest in the truth.',
  },
  {
    reference: '2 JOHN 7',
    referenceURL: 'https://www.bible.com/bible/1/2JN.1.7.KJV',
    verseText:
      'For many deceivers are entered into the world, who confess not that Jesus Christ is come in the flesh. This is a deceiver and an antichrist.',
  },
  {
    reference: 'PHILEMON 20',
    referenceURL: 'https://www.bible.com/bible/1/PHM.1.20.KJV',
    verseText:
      'Yea, brother, let me have joy of thee in the Lord: refresh my bowels in the Lord.',
  },
  {
    reference: 'PHILEMON 7',
    referenceURL: 'https://www.bible.com/bible/1/PHM.1.7.KJV',
    verseText:
      'For we have great joy and consolation in thy love, because the bowels of the saints are refreshed by thee, brother.',
  },
  {
    reference: 'OBADIAH 21',
    referenceURL: 'https://www.bible.com/bible/1/OBA.1.21.KJV',
    verseText:
      "And saviours shall come up on mount Zion to judge the mount of Esau; and the kingdom shall be the LORD's.",
  },
  {
    reference: '2 JOHN 1',
    referenceURL: 'https://www.bible.com/bible/1/2JN.1.1.KJV',
    verseText:
      'The elder unto the elect lady and her children, whom I love in the truth; and not I only, but also all they that have known the truth',
  },
  {
    reference: 'OBADIAH 15',
    referenceURL: 'https://www.bible.com/bible/1/OBA.1.15.KJV',
    verseText:
      'For the day of the LORD is near upon all the heathen: as thou hast done, it shall be done unto thee: thy reward shall return upon thine own head.',
  },
  {
    reference: 'OBADIAH 4',
    referenceURL: 'https://www.bible.com/bible/1/OBA.1.4.KJV',
    verseText:
      'Though thou exalt thyself as the eagle, and though thou set thy nest among the stars, thence will I bring thee down, saith the LORD.',
  },
  {
    reference: 'PHILEMON 18',
    referenceURL: 'https://www.bible.com/bible/1/PHM.1.18.KJV',
    verseText:
      'If he hath wronged thee, or oweth thee ought, put that on mine account',
  },
  {
    reference: 'PHILEMON 10',
    referenceURL: 'https://www.bible.com/bible/1/PHM.1.10.KJV',
    verseText:
      'I beseech thee for my son Onesimus, whom I have begotten in my bonds',
  },
  {
    reference: '2 JOHN 5',
    referenceURL: 'https://www.bible.com/bible/1/2JN.1.5.KJV',
    verseText:
      'And now I beseech thee, lady, not as though I wrote a new commandment unto thee, but that which we had from the beginning, that we love one another.',
  },
  {
    reference: '2 JOHN 9',
    referenceURL: 'https://www.bible.com/bible/1/2JN.1.9.KJV',
    verseText:
      'Whosoever transgresseth, and abideth not in the doctrine of Christ, hath not God. He that abideth in the doctrine of Christ, he hath both the Father and the Son.',
  },
  {
    reference: '2 JOHN 6',
    referenceURL: 'https://www.bible.com/bible/1/2JN.1.6.KJV',
    verseText:
      'And this is love, that we walk after his commandments. This is the commandment, That, as ye have heard from the beginning, ye should walk in it.',
  },
  {
    reference: '3 JOHN 4',
    referenceURL: 'https://www.bible.com/bible/1/3JN.1.4.KJV',
    verseText:
      'I have no greater joy than to hear that my children walk in truth.',
  },
  {
    reference: '2 JOHN 12',
    referenceURL: 'https://www.bible.com/bible/1/2JN.1.12.KJV',
    verseText:
      'Having many things to write unto you, I would not write with paper and ink: but I trust to come unto you, and speak face to face, that our joy may be full.',
  },
  {
    reference: 'OBADIAH 18',
    referenceURL: 'https://www.bible.com/bible/1/OBA.1.18.KJV',
    verseText:
      'And the house of Jacob shall be a fire, and the house of Joseph a flame, and the house of Esau for stubble, and they shall kindle in them, and devour them; and there shall not be any remaining of the house of Esau; for the LORD hath spoken it.',
  },
  {
    reference: '3 JOHN 11',
    referenceURL: 'https://www.bible.com/bible/1/3JN.1.11.KJV',
    verseText:
      'Beloved, follow not that which is evil, but that which is good. He that doeth good is of God: but he that doeth evil hath not seen God.',
  },
  {
    reference: 'OBADIAH 17',
    referenceURL: 'https://www.bible.com/bible/1/OBA.1.17.KJV',
    verseText:
      'But upon mount Zion shall be deliverance, and there shall be holiness; and the house of Jacob shall possess their possessions.',
  },
  {
    reference: 'JUDE 24',
    referenceURL: 'https://www.bible.com/bible/1/JUD.1.24.KJV',
    verseText:
      'Now unto him that is able to keep you from falling, and to present you faultless before the presence of his glory with exceeding joy',
  },
  {
    reference: '2 JOHN 4',
    referenceURL: 'https://www.bible.com/bible/1/2JN.1.4.KJV',
    verseText:
      'I rejoiced greatly that I found of thy children walking in truth, as we have received a commandment from the Father.',
  },
  {
    reference: 'PHILEMON 17',
    referenceURL: 'https://www.bible.com/bible/1/PHM.1.17.KJV',
    verseText: 'If thou count me therefore a partner, receive him as myself.',
  },
]
